// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:35:06.873Z
// Property: Warrington Apartments (ID: 6767906449165642)
// Collections: 18 amenities, 8 floorplans (live), 20 photos, 77 POIs, 3 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165642",
  "property_external_id": "vj29vze",
  "property_zillow_url": "https://www.zillow.com/b/macarthur-ave-%2C-tract-4-oklahoma-city-ok-BZydwm/",
  "property_apartments_url": "https://www.apartments.com/warrington-apartments-oklahoma-city-ok/vj29vze/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Warrington+Apartments/data=!4m2!3m1!1s0x0:0x3f3b79f1301b9a62?sa=X&ved=2ahUKEwi0mLD0gr2SAxVLkYkEHfHYOnoQ_BJ6BAgVEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "warrington-apartments",
  "property_name": "Warrington Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/warrington/",
  "property_domain": null,
  "property_address": "12700 North MacArthur",
  "property_full_address": "12700 North MacArthur, Oklahoma City, OK, 73142",
  "property_address_1": "12700 North MacArthur",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73142",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Val Verde",
  "property_address_latitude": "35.6",
  "property_address_longitude": "-97.6192",
  "property_email": "warrington@caseusa.com",
  "property_phone": "(405) 374-5108",
  "property_call_tracking_phone": "844-545-0337",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Warrington Apartments in Oklahoma City, comfort and convenience collide. Choose from spacious one and two-bedroom floor plans, and enjoy amenities like a refreshing pool, modern fitness center, and serene sundeck. Experience a vibrant community with a picnic area and on-site maintenance. Make Warrington your new home today—schedule a tour! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Warrington Apartments, your ideal home in the heart of Oklahoma City! Our vibrant community offers an array of thoughtfully designed floor plans, featuring spacious one and two-bedroom apartments that cater to your lifestyle needs. Each home is equipped with modern amenities such as in-unit washers and dryers, air conditioning, and sleek kitchen appliances, ensuring comfort and convenience at your fingertips.\n\nExperience leisure at its finest with our inviting swimming pool and sundeck, perfect for soaking up the sun with friends and family. Stay active in our fully equipped fitness center, or enjoy a serene afternoon in our beautifully landscaped courtyard and picnic area. Our community is designed with your peace of mind in mind, offering controlled access, on-site maintenance, and a dedicated property manager available to assist you.\n\nAt Warrington Apartments, you can enjoy the smoke-free lifestyle you desire, alongside features like high-speed internet access, spacious walk-in closets, and cozy fireplaces in select units. With a gated entrance and walk-up access, you’ll feel secure and at home from the moment you arrive.\n\nDon’t miss out on the opportunity to live in this fantastic community. Find your new home today—browse our availability or schedule a tour to visit Warrington Apartments and experience all that we have to offer! Whether you’re ready to move in or just exploring your options, we’re here to help you every step of the way.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4d-430f-71b1-a431-af46ca883872.webp",
  "property_featured_image_media": {
    "alt_text": "The Warrington monument sign with exterior buildings in the background.",
    "public_id": "019cfb4d-430f-71b1-a431-af46ca883872",
    "storage_key": "property/6767906449165642/019cfb4d-430f-71b1-a431-af46ca883872.webp",
    "width": 2048,
    "height": 1366
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "204",
  "property_year_built": "1983",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.05882352941177",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "No aggressive breeds",
  "property_pet_policy_description": "We welcome cats and dogs with no weight limit. Maximum of two pets per unit. Pet fee: $500 per pet (non‑refundable). Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://warringtonapartmentsoklahomacity.securecafe.com/onlineleasing/warrington-apartments/floorplans.aspx",
  "property_resident_portal_url": "https://warringtonapartmentsoklahomacity.securecafe.com/residentservices/warrington-apartments/userlogin.aspx",
  "property_apply_now_url": "https://warringtonapartmentsoklahomacity.securecafe.com/onlineleasing/warrington-apartments/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-4510-72ba-9132-65724c7993af.webp",
  "property_primary_logo_media": {
    "alt_text": "The Warrington Apartments logo.",
    "public_id": "019cfb4c-4510-72ba-9132-65724c7993af",
    "storage_key": "property/6767906449165642/019cfb4c-4510-72ba-9132-65724c7993af.webp",
    "width": 300,
    "height": 90
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4d-3737-70a9-85b9-38c36ec178a7.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb4d-3737-70a9-85b9-38c36ec178a7",
    "storage_key": "property/6767906449165642/019cfb4d-3737-70a9-85b9-38c36ec178a7.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4d-5b33-7689-9ed6-e9ab8e884f89.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Warrington Apartments logo",
    "public_id": "019cfb4d-5b33-7689-9ed6-e9ab8e884f89",
    "storage_key": "property/6767906449165642/019cfb4d-5b33-7689-9ed6-e9ab8e884f89.webp",
    "width": 300,
    "height": 90
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4d-62e6-738b-a324-5cfbf47f7144.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Warrington Apartments logo",
    "public_id": "019cfb4d-62e6-738b-a324-5cfbf47f7144",
    "storage_key": "property/6767906449165642/019cfb4d-62e6-738b-a324-5cfbf47f7144.webp",
    "width": 300,
    "height": 90
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#4f4942",
  "property_secondary_color": "#867e70",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#eae0c8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "690 - 978",
  "property_sqft_min": "690",
  "property_sqft_max": "978",
  "property_price_range": "1029 - 1179",
  "property_price_min": "1029",
  "property_price_max": "1179",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/WarringtonApt/posts/at-warrington-apartments-in-oklahoma-city-pets-are-always-welcome-enjoy-a-pet-fr/1514658613998343/",
  "property_instagram_url": "https://www.instagram.com/warringtonapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJtUGUSU4DsocRYpobMPF5Oz8",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-warrington-apartments-oklahoma-city-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Warrington Apartments",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Home",
  "property_home_amenities_blurb": "Welcome to Warrington Apartments in vibrant Oklahoma City! Choose between spacious one- and two-bedroom layouts designed for comfort and style. Enjoy amenities like a refreshing pool, a modern fitness center, and a tranquil courtyard—perfect for relaxation. Elevate your living experience with us today!",
  "property_home_floorplans_blurb": "At Warrington Apartments in vibrant Oklahoma City, your dream home awaits! Choose from our stylish one-bedroom and spacious two-bedroom layouts, designed with modern living in mind. Dive into our selection and let the ideal floor plan elevate your lifestyle. Start your journey to comfortable apartment living today!",
  "property_home_gallery_blurb": "Welcome to Warrington Apartments in vibrant Oklahoma City, where comfort meets style. Our thoughtfully designed one and two-bedroom homes feature modern amenities like a refreshing pool, fitness center, and inviting sundeck. Enjoy convenient living with on-site maintenance, gated access, and spacious outdoor areas. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Warrington Apartments in Oklahoma City, experience a vibrant lifestyle surrounded by a wealth of attractions. From the stunning Blue Zoo Aquarium to the engaging Oklahoma Museum of Flying, there's always something to spark your curiosity nearby. Embrace convenience with major retailers and parks just moments away—your ideal home awaits!",
  "property_home_reviews_blurb": "At Warrington Apartments in Oklahoma City, residents cherish a caring atmosphere and prompt service, with one resident sharing, “I feel heard and safe.” Our dedicated staff ensures swift resolution of maintenance requests and maintains beautiful grounds, creating a true sense of community. Join us and experience the difference!",
  "property_neighborhood_blurb": "Nestled in the heart of Oklahoma City, Warrington Apartments offers convenient access to a vibrant community. Enjoy nature at Martin Park, explore the Oklahoma Museum of Flying, or catch a game at SNU Football Stadium nearby. Uncover local favorites and enriching experiences just steps from your front door!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Warrington Apartments in Oklahoma City, indulge in a lifestyle where comfort meets convenience. Enjoy refreshing swims in our pool, energizing workouts in the fitness center, and leisurely gatherings in the picnic area. With spacious one- and two-bedroom layouts and a host of exceptional amenities, your ideal home awaits. ",
  "property_applynow_blurb": "At Warrington Apartments in Oklahoma City, find your ideal living space with our cozy one and two-bedroom floor plans. Enjoy lush amenities including a refreshing pool, modern fitness center, and serene picnic areas. With controlled access and on-site management, your perfect home awaits—lease online today and step into comfort!",
  "property_contactus_blurb": "At Warrington Apartments in Oklahoma City, our thoughtfully designed one and two-bedroom floor plans cater to your unique lifestyle. Whether you seek cozy comfort or spacious living, we have the perfect fit for you. Have questions? Contact our leasing team today for personalized assistance and to learn more!",
  "property_faqs_blurb": "At Warrington Apartments in Oklahoma City, we offer thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Have questions? Our FAQs page is filled with valuable insights to help you navigate our vibrant community and discover all that we have to offer. Your new home awaits!",
  "property_floorplans_blurb": "At Warrington Apartments in Oklahoma City, you’ll find a variety of thoughtfully designed floor plans, including cozy one-bedroom and spacious two-bedroom options. Each layout is crafted for comfort and style. Browse our available apartment homes and uncover the ideal space that fits your lifestyle today!",
  "property_gallery_blurb": "At Warrington Apartments in Oklahoma City, your ideal lifestyle awaits. Choose from spacious one or two-bedroom floor plans featuring modern amenities like a refreshing pool, state-of-the-art fitness center, and inviting picnic areas. With on-site management and a smoke-free environment, picture yourself enjoying this vibrant community at every turn!",
  "property_interactivemap_blurb": "At Warrington Apartments in vibrant Oklahoma City, your ideal home awaits! Choose from spacious one and two-bedroom layouts, complete with modern amenities like a refreshing pool, fitness center, and sundeck. Use our interactive community map to find your perfect space—your new lifestyle starts here!",
  "property_pets_blurb": "At Warrington Apartments in Oklahoma City, your furry friends are celebrated! With no weight limits and space for two pets per unit, our community creates a haven for pet lovers. Enjoy the convenience of local parks and pet-friendly amenities, all while making your home in a vibrant neighborhood.",
  "property_referafriend_blurb": "At Warrington Apartments in Oklahoma City, we believe great friends make great neighbors! With spacious one and two-bedroom floor plans, our community is the perfect place to share life’s moments. Spread the word and invite your friends to experience the comfort and camaraderie of Warrington—refer a friend today!",
  "property_residentaccess_blurb": "Welcome to Warrington Apartments in vibrant Oklahoma City, where comfort meets convenience. Choose from spacious one or two-bedroom floor plans tailored to your lifestyle. Access your resident portal effortlessly to manage rent, schedule maintenance, and enjoy a seamless living experience. Join our community today and elevate your home life!",
  "property_reviews_blurb": "At Warrington Apartments in Oklahoma City, residents feel right at home, thanks to our dedicated staff and pristine grounds. With a 4-star average rating, one happy resident shares, \"I love living here... The grounds are kept in beautiful condition.\" Experience the caring atmosphere that makes our community truly special!",
  "property_created_at": "1753982397122",
  "property_scheduletour_blurb": "At Warrington Apartments in vibrant Oklahoma City, find the perfect fit with our stylish one- and two-bedroom floor plans. Experience community living at its finest and enjoy spacious layouts designed for modern lifestyles. Curious? Schedule a tour today and hear firsthand from our residents about their exceptional experiences!",
  "property_thankyou_blurb": "Thank you for reaching out! At Warrington Apartments in Oklahoma City, our diverse floor plans, featuring one and two-bedroom options, cater to your lifestyle. A team member will connect with you soon, ready to guide you toward your perfect new home in our welcoming community. Stay tuned! ",
  "property_virtualtours_blurb": "Step inside Warrington Apartments in vibrant Oklahoma City, where modern living meets comfort. Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Experience the unique charm of our community—take a virtual tour today and envision your next home with us!",
  "property_copyright": "2025 All Rights Reserved. Warrington Apartments",
  "property_seo_title_home": "Warrington Apartments |  Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_home": "Experience modern living at Warrington Apartments in Oklahoma City! With spacious floor plans, a stunning pool, and a vibrant community, your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Warrington Apartments in Oklahoma City. Browse our unique one and two-bedroom floor plans tailored for your lifestyle today!",
  "property_seo_title_amenities": "Amenities | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience the comfort of Warrington Apartments in OKC! Enjoy a pool, fitness center, and spacious floor plans with modern amenities. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_gallery": "Experience Warrington Apartments in OKC! Enjoy spacious layouts, a sparkling pool, and modern amenities like a fitness center. You belong here!",
  "property_seo_title_virtualtours": "Virtual Tours | Warrington Apartments Apartments",
  "property_seo_description_virtualtours": "Step inside Warrington Apartments in Oklahoma City! Take a virtual tour of our stylish one and two-bedroom floor plans today. Your perfect home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Warrington Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Warrington Apartments in Oklahoma City! Use our interactive map to explore spacious floor plans and fantastic amenities today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding Warrington Apartments in Oklahoma City. Delight in local hotspots and hidden gems just around the corner!",
  "property_seo_title_contact": "Contact Us | Warrington Apartments",
  "property_seo_description_contact": "Uncover your perfect home at Warrington Apartments in Oklahoma City. Reach out to our team today with any questions about our one and two-bedroom floor plans!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_faqs": "Get the scoop on Warrington Apartments in Oklahoma City! Our FAQs page answers all your burning questions about our amenities, floor plans, and community life.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_reviews": "Join our Warrington Apartments community in Oklahoma City! Enjoy modern amenities, spacious layouts, and a vibrant lifestyle. Check out resident reviews today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_applynow": "Find your perfect retreat at Warrington Apartments in OKC! Enjoy luxurious amenities, spacious floor plans, and a vibrant community. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Warrington Apartments",
  "property_seo_description_residentaccess": "Unlock convenience at Warrington Apartments! Access your resident portal to effortlessly pay rent, schedule maintenance, and manage your home in Oklahoma City.",
  "property_seo_title_referafriend": "Refer A Friend | Warrington Apartments",
  "property_seo_description_referafriend": "Refer a friend to Warrington Apartments in Oklahoma City! Enjoy a vibrant community where great friendships blossom. Your next door neighbor could be a friend!",
  "property_seo_title_scheduletour": "Schedule a Tour | Warrington Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Warrington Apartments in Oklahoma City. Schedule a tour today and envision your next home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Warrington Apartments",
  "property_seo_description_privacy": "Your trust matters! Read the Warrington Apartments privacy policy to understand how we protect your information while you enjoy life in vibrant Oklahoma City.",
  "property_seo_title_accessibility": "Website Accessibility | Warrington Apartments",
  "property_seo_description_accessibility": "At Warrington Apartments in OKC, we promote digital inclusion and accessible living for all. Join us in fostering a welcoming community!",
  "property_seo_title_sitemap": "Sitemap | Warrington Apartments",
  "property_seo_description_sitemap": "Uncover the charm of Warrington Apartments in Oklahoma City! Navigate our sitemap to find your perfect home and embrace a vibrant community lifestyle.",
  "property_seo_title_thankyou": "Thank You | Warrington Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Warrington Apartments! A team member will connect soon to help you find your perfect home in vibrant Oklahoma City.",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866125490",
  "amenities": [
    {
      "id": "ec_e9d918c8c63a4b73b6ba3f16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127397469",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a1f18df53251cb713264c4c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127397471",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52f1cb9a9b41f46f50068326",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127397472",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6a9d9e46c5be10778e4f6dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127397473",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a17b5077eb5128b9598b8f36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127397474",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eabb01bf16868a361648a97d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127397475",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_926aa716b9e99a25888786ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127397476",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c6019ec902ef8e22e0f27a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "128042566",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98c949480f4c3a0c9fdb18c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "128017295",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea690df8b08ec2ebf725e039",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127398935",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_777f6bade4a2ceaf8a714381",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127398936",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22eafbfbb6387c09cb8b7eb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127398937",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c985549975bfaf5b25757f2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127398938",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0aca7788d827850b1c79f2c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127398939",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c7ff126b9b1be627c56fd18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127398940",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5030601af648c9026f3dfee5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127398941",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a581c313833a3333564c25c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127398942",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a6936c7a3fd35c3cbf5b6a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "yardi",
      "external_id": "127398943",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4500eb49-9b7e-4350-b6da-8cd167393278",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-60a2-731b-9d15-ccc8c9f20a42.webp",
      "image_media": {
        "alt_text": "Exterior view of The Warrington apartment community sign with brick and landscaping.",
        "public_id": "019d20b0-60a2-731b-9d15-ccc8c9f20a42",
        "storage_key": "property/6767906449165642/019d20b0-60a2-731b-9d15-ccc8c9f20a42.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of The Warrington apartment community featuring a brick sign, landscaped greenery, and a multi-unit building.",
      "link": "",
      "alt_text": "Exterior view of The Warrington apartment community sign with brick and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-0641-706f-bc24-35d7fca32ca0.webp"
    },
    {
      "id": "custom_f303cfe8-9355-4f74-8b1c-f172ee4b6722",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-60ab-777f-9c9b-64fea1b510ae.webp",
      "image_media": {
        "alt_text": "Entrance to an apartment building with a glass door, bench, and landscaped plantings.",
        "public_id": "019d20b0-60ab-777f-9c9b-64fea1b510ae",
        "storage_key": "property/6767906449165642/019d20b0-60ab-777f-9c9b-64fea1b510ae.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcoming entry to a multifamily community with brick columns, a seating bench, and a colorful garden.",
      "link": "",
      "alt_text": "Entrance to an apartment building with a glass door, bench, and landscaped plantings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-18d6-747c-802d-ce9fa681fcad.webp"
    },
    {
      "id": "custom_cccd06cc-4382-40a9-bae3-9cd6d2c9f3df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-60a3-716c-a82d-cd0e703c0fa4.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with lounge chairs and umbrellas at an apartment community.",
        "public_id": "019d20b0-60a3-716c-a82d-cd0e703c0fa4",
        "storage_key": "property/6767906449165642/019d20b0-60a3-716c-a82d-cd0e703c0fa4.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "A welcoming outdoor pool area with lounge seating, umbrellas, and landscaped surroundings at the apartment community.",
      "link": "",
      "alt_text": "Outdoor pool area with lounge chairs and umbrellas at an apartment community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-16a3-7059-9846-b494aab7d9e6.webp"
    },
    {
      "id": "custom_95caebb7-ebfa-4d38-a028-b9890f291fdb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-606c-747f-a820-8a774fb4593e.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills and an elliptical trainer by large windows.",
        "public_id": "019d20b0-606c-747f-a820-8a774fb4593e",
        "storage_key": "property/6767906449165642/019d20b0-606c-747f-a820-8a774fb4593e.webp",
        "width": 500,
        "height": 334
      },
      "title": "Community",
      "description": "Bright community gym with cardio equipment and a modern tiled floor.",
      "link": "",
      "alt_text": "Fitness center with treadmills and an elliptical trainer by large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165642/019cfb4c-4557-73f9-a5bc-101a655cb285.webp"
    },
    {
      "id": "custom_45e5f6a4-0417-416a-91d6-7267d3a2eafe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-69d2-7090-b1ec-05b2782ac065.webp",
      "image_media": {
        "alt_text": "Inside a modern apartment community gym with treadmills, weights, and blue-tiled flooring.",
        "public_id": "019d20b0-69d2-7090-b1ec-05b2782ac065",
        "storage_key": "property/6767906449165642/019d20b0-69d2-7090-b1ec-05b2782ac065.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Interior view of the property's fitness center featuring cardio machines, weight equipment, and colorful flooring.",
      "link": "",
      "alt_text": "Inside a modern apartment community gym with treadmills, weights, and blue-tiled flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165642/019cfb4c-4554-7494-8c54-2755eca3a46c.webp"
    },
    {
      "id": "custom_fec78351-fb14-4327-a966-9452ab6f8f2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-69e3-728f-8288-39095e67b5d0.webp",
      "image_media": {
        "alt_text": "Outdoor community pool area with seating, umbrellas, and brick accents.",
        "public_id": "019d20b0-69e3-728f-8288-39095e67b5d0",
        "storage_key": "property/6767906449165642/019d20b0-69e3-728f-8288-39095e67b5d0.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Outdoor pool area for residents with lounge seating, umbrellas, and brick/stone features.",
      "link": "",
      "alt_text": "Outdoor community pool area with seating, umbrellas, and brick accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165642/019cfb4c-4554-7494-8c54-28d407a22f98.webp"
    },
    {
      "id": "custom_424cd16a-b769-4615-9b0f-ebe53e286712",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-6a03-762c-9faf-1098acb213fe.webp",
      "image_media": {
        "alt_text": "Outdoor community swimming pool with brick buildings and a stone waterfall feature.",
        "public_id": "019d20b0-6a03-762c-9faf-1098acb213fe",
        "storage_key": "property/6767906449165642/019d20b0-6a03-762c-9faf-1098acb213fe.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Bright outdoor pool area at a multifamily community, featuring a brick-wrapped backdrop and landscaped surroundings.",
      "link": "",
      "alt_text": "Outdoor community swimming pool with brick buildings and a stone waterfall feature.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165642/019cfb4c-4556-7526-8356-4bd7fd820069.webp"
    },
    {
      "id": "custom_19c57712-2cee-4e9b-8c94-8ff9c5c93049",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-6b44-74f2-beef-88f09b73dbb7.webp",
      "image_media": {
        "alt_text": "Exterior view of brick apartment buildings with balconies and a parking lot.",
        "public_id": "019d20b0-6b44-74f2-beef-88f09b73dbb7",
        "storage_key": "property/6767906449165642/019d20b0-6b44-74f2-beef-88f09b73dbb7.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Exterior view of a brick apartment community with balconies and surrounding parking.",
      "link": "",
      "alt_text": "Exterior view of brick apartment buildings with balconies and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165642/019cfb4c-458f-755d-9f49-a9ea7f5f9c6c.webp"
    },
    {
      "id": "custom_a71b0472-fee4-40a7-8790-2ef401a985a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-7287-7292-9f2f-dabcd1a46e8e.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment complex with multiple entrances, a parking lot, and clear blue sky.",
        "public_id": "019d20b0-7287-7292-9f2f-dabcd1a46e8e",
        "storage_key": "property/6767906449165642/019d20b0-7287-7292-9f2f-dabcd1a46e8e.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Exterior view of a multi-building apartment community with brick siding, white trim, and a surrounding parking lot.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment complex with multiple entrances, a parking lot, and clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165642/019cfb4c-4554-7494-8c54-23ead7f13cb0.webp"
    },
    {
      "id": "custom_e89537e7-beea-4ea1-aadb-44f352b83bfc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-72e8-702d-ba4b-c1bc457b4031.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, and sliding glass doors to a balcony; kitchen visible.",
        "public_id": "019d20b0-72e8-702d-ba4b-c1bc457b4031",
        "storage_key": "property/6767906449165642/019d20b0-72e8-702d-ba4b-c1bc457b4031.webp",
        "width": 1240,
        "height": 827
      },
      "title": "Apartment",
      "description": "Bright open living area in a multifamily apartment with seating, dining area, and a view into the kitchen.",
      "link": "",
      "alt_text": "Living room with sofa, armchair, coffee table, and sliding glass doors to a balcony; kitchen visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165642/019cfb4c-4556-7526-8356-4eeb315a29b9.webp"
    },
    {
      "id": "custom_67da4f17-98f3-4fbc-8c97-429a61da5895",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-791a-767d-9cb4-2fba8950f055.webp",
      "image_media": {
        "alt_text": "Bathroom interior with sink, vanity, mirror, toilet, and a patterned shower curtain.",
        "public_id": "019d20b0-791a-767d-9cb4-2fba8950f055",
        "storage_key": "property/6767906449165642/019d20b0-791a-767d-9cb4-2fba8950f055.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Apartment",
      "description": "A clean, compact apartment bathroom featuring a wooden vanity, framed art, and a light-patterned shower curtain.",
      "link": "",
      "alt_text": "Bathroom interior with sink, vanity, mirror, toilet, and a patterned shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-0325-756a-8154-6dccfa9600e7.webp"
    },
    {
      "id": "custom_3dd15102-e37a-4197-8cd2-982eed9c1e1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-7ce5-77d9-b4f6-77da217553a8.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a gray sofa, coffee table, and wood-paneled fireplace.",
        "public_id": "019d20b0-7ce5-77d9-b4f6-77da217553a8",
        "storage_key": "property/6767906449165642/019d20b0-7ce5-77d9-b4f6-77da217553a8.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Cozy, modern living room in a multifamily apartment with neutral tones and a wood-paneled fireplace.",
      "link": "",
      "alt_text": "Living room in an apartment with a gray sofa, coffee table, and wood-paneled fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-032f-7329-b19d-a7ee8acf79ab.webp"
    },
    {
      "id": "custom_5e542b92-95dd-4299-a9b7-08bf890545ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-7d2f-76bb-a3ad-4894999398fb.webp",
      "image_media": {
        "alt_text": "Bedroom in a furnished apartment with a dark wood bed frame, nightstands, lamps, and a ceiling fan.",
        "public_id": "019d20b0-7d2f-76bb-a3ad-4894999398fb",
        "storage_key": "property/6767906449165642/019d20b0-7d2f-76bb-a3ad-4894999398fb.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Furnished apartment bedroom with dark wood furniture and soft ambient lighting.",
      "link": "",
      "alt_text": "Bedroom in a furnished apartment with a dark wood bed frame, nightstands, lamps, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-0639-742f-b381-933d3dacc269.webp"
    },
    {
      "id": "custom_d988c420-9637-43f4-a76e-820ec007ff85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-7d46-705c-959f-245601cc5628.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, double sink, white appliances, and decorative plants.",
        "public_id": "019d20b0-7d46-705c-959f-245601cc5628",
        "storage_key": "property/6767906449165642/019d20b0-7d46-705c-959f-245601cc5628.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with oak cabinets, white appliances, a double sink, and decorative touches.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, double sink, white appliances, and decorative plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-0361-732b-933e-f9a1df67e25b.webp"
    },
    {
      "id": "custom_bea09676-c65f-43a0-a74c-c57357427997",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-84a0-742a-814c-edd31d9b7002.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a gray sofa, a patterned armchair, coffee table, and vertical blinds.",
        "public_id": "019d20b0-84a0-742a-814c-edd31d9b7002",
        "storage_key": "property/6767906449165642/019d20b0-84a0-742a-814c-edd31d9b7002.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Cozy apartment living room featuring a gray sofa, a patterned armchair, a coffee table, and vertical blinds.",
      "link": "",
      "alt_text": "Living room in an apartment with a gray sofa, a patterned armchair, coffee table, and vertical blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-162e-7055-bc87-e18552111fb2.webp"
    },
    {
      "id": "custom_4d4e2fe2-d5f8-4cd1-ac50-54962bd99a01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-8705-704b-89b5-47e157107230.webp",
      "image_media": {
        "alt_text": "Bathroom with a tub/shower combo, striped blue-gray curtain, toilet, and vanity.",
        "public_id": "019d20b0-8705-704b-89b5-47e157107230",
        "storage_key": "property/6767906449165642/019d20b0-8705-704b-89b5-47e157107230.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a striped shower curtain, single-sink vanity, and large mirror.",
      "link": "",
      "alt_text": "Bathroom with a tub/shower combo, striped blue-gray curtain, toilet, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-0641-706f-bc24-3b4a046b4c2a.webp"
    },
    {
      "id": "custom_3e9b3ecc-634d-4747-a16a-997674ef9cb3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-87f2-7349-b7c2-f7149a21f5f5.webp",
      "image_media": {
        "alt_text": "Open living room with gray sofa, patterned armchair, coffee table, and sliding glass doors.",
        "public_id": "019d20b0-87f2-7349-b7c2-f7149a21f5f5",
        "storage_key": "property/6767906449165642/019d20b0-87f2-7349-b7c2-f7149a21f5f5.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Bright open-concept living area with a partial kitchen and dining nook in a modern apartment.",
      "link": "",
      "alt_text": "Open living room with gray sofa, patterned armchair, coffee table, and sliding glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-1db3-7029-86b0-f67b1c38dd96.webp"
    },
    {
      "id": "custom_8c5fd35c-2c5e-4339-b712-9fca3187c9a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-90fd-740a-a605-2bcb34567039.webp",
      "image_media": {
        "alt_text": "Bedroom with dark upholstered bed, dresser with round mirror, and ceiling fan.",
        "public_id": "019d20b0-90fd-740a-a605-2bcb34567039",
        "storage_key": "property/6767906449165642/019d20b0-90fd-740a-a605-2bcb34567039.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with a dark upholstered bed, dresser with round mirror, and soft lighting.",
      "link": "",
      "alt_text": "Bedroom with dark upholstered bed, dresser with round mirror, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-0641-706f-bc24-3f4c0ff9f317.webp"
    },
    {
      "id": "custom_5a9e5146-b77a-4050-a5b3-6f1f21773506",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-9191-77ce-b46e-07b582f20acc.webp",
      "image_media": {
        "alt_text": "Compact kitchen with white stove and refrigerator, double sink, and wooden cabinets.",
        "public_id": "019d20b0-9191-77ce-b46e-07b582f20acc",
        "storage_key": "property/6767906449165642/019d20b0-9191-77ce-b46e-07b582f20acc.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Cozy apartment kitchen featuring white appliances, a double sink, ample counter space, and warm wood cabinets.",
      "link": "",
      "alt_text": "Compact kitchen with white stove and refrigerator, double sink, and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-063d-722f-bac6-8961729ccf5a.webp"
    },
    {
      "id": "custom_e7467199-4fe7-4767-bb38-50e151ab86f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d20b0-92e2-70ac-985f-b4000f318d18.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment featuring a long vanity, single sink, mirror, and tub/shower combo.",
        "public_id": "019d20b0-92e2-70ac-985f-b4000f318d18",
        "storage_key": "property/6767906449165642/019d20b0-92e2-70ac-985f-b4000f318d18.webp",
        "width": 500,
        "height": 334
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with ample vanity storage, a single sink, and a tub/shower combo.",
      "link": "",
      "alt_text": "Bathroom in an apartment featuring a long vanity, single sink, mirror, and tub/shower combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165642/019cfb4c-4554-7494-8c54-2e8de786e617.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_89094418-273d-4920-8f70-7289763085ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Topgolf Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "13313 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Entertainment venue blending technology, dining, and golf with a sports bar, and rooftop seating.",
      "poi_long_description": "People say this restaurant offers a fun atmosphere with games, kid clubs, and toddler clubs. They also highlight the affordable pricing, especially for groups, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-b0ff-70de-adc2-30612cebbec7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b0ff-70de-adc2-30612cebbec7",
        "storage_key": "property/6767906449165642/019d2709-b0ff-70de-adc2-30612cebbec7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17880991546737991946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-oklahoma-city",
      "poi_latitude": "35.6027127",
      "poi_longitude": "-97.5351879",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-607-7154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e484-706d-adf7-9c2b1828428c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e484-706d-adf7-9c2b1828428c",
        "storage_key": "property/6767906449165642/019d2709-e484-706d-adf7-9c2b1828428c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0r8qRocsocRCqEU_xILJvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6ffc50ca-946d-4ab1-a444-60209d59dbd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Main Event Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1441 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Family-friendly venue offering bowling, laser tag and arcade games, along with pizza and burgers, plus a ropes course.",
      "poi_long_description": "People say this restaurant offers a variety of fun games, including bowling, laser tag, and arcade games, and the pizza is great. They also highlight the friendly staff, the fun atmosphere, and the good drinks.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-b12a-73d9-b98a-653869f1e7c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b12a-73d9-b98a-653869f1e7c7",
        "storage_key": "property/6767906449165642/019d2709-b12a-73d9-b98a-653869f1e7c7.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/oklahoma/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=10621058190493493742&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-oklahoma-city",
      "poi_latitude": "35.6102071",
      "poi_longitude": "-97.5381584",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-751-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e484-706d-adf7-9c2b1828428c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e484-706d-adf7-9c2b1828428c",
        "storage_key": "property/6767906449165642/019d2709-e484-706d-adf7-9c2b1828428c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bkHxccsocR7ikexyaUZZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_edf10f8c-a776-40ec-9bd6-e810eb8caf23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2100 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Chain serving steaks and ribs in a casual setting featuring a jukebox and line dancers.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, chicken fried steak, and ribs, and the rolls with cinnamon butter are a highlight. They also highlight the friendly and accommodating staff, and the family-friendly atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-b15d-778f-b83a-5215c35cf7be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b15d-778f-b83a-5215c35cf7be",
        "storage_key": "property/6767906449165642/019d2709-b15d-778f-b83a-5215c35cf7be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-north-memorial-rd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3657567219942529703&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.6078943",
      "poi_longitude": "-97.5503319",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-755-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e484-706d-adf7-9c2b1828428c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e484-706d-adf7-9c2b1828428c",
        "storage_key": "property/6767906449165642/019d2709-e484-706d-adf7-9c2b1828428c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYzghGscsocRp5rJBgJKwjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_9b7a443f-780b-41e2-bbb2-2e0709b45529",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Clark Crew BBQ",
      "poi_type": "Restaurants",
      "poi_address": "3510 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Casual establishment with a patio for pit-smoked beef brisket, ribs, pulled pork and more.",
      "poi_long_description": "Diners say this barbecue restaurant serves up delicious burnt ends, brisket, ribs, and sausage, with sides of mac and cheese, baked beans, and cornbread. They also highlight the friendly and attentive service, and the lively back patio with live music.\n\nSome reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-b0d9-75a7-b5dd-90ef84e85031.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b0d9-75a7-b5dd-90ef84e85031",
        "storage_key": "property/6767906449165642/019d2709-b0d9-75a7-b5dd-90ef84e85031.webp",
        "width": 599,
        "height": 596
      },
      "poi_business_url": "http://www.clarkcrewbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3587788996052338906&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clark-crew-bbq",
      "poi_latitude": "35.5323986",
      "poi_longitude": "-97.5816496",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-724-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e484-706d-adf7-9c2b1828428c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e484-706d-adf7-9c2b1828428c",
        "storage_key": "property/6767906449165642/019d2709-e484-706d-adf7-9c2b1828428c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6r6_-4asocR2kjBPhVjyjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_20be2d46-e13f-4a5d-b18f-1b68a02a638d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Meddys",
      "poi_type": "Restaurants",
      "poi_address": "9404 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious dishes like the Meddys Main Plate, hummus bowl, and garlic chicken, with generous portions and fresh, flavorful ingredients. They highlight the reasonable prices, casual and modern atmosphere, and the availability of outdoor seating and live music. They also like the friendly and attentive staff, and the quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-b62f-7507-95f4-d5d733e8858b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b62f-7507-95f4-d5d733e8858b",
        "storage_key": "property/6767906449165642/019d2709-b62f-7507-95f4-d5d733e8858b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.meddys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10733599644329479405&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meddys",
      "poi_latitude": "35.56632889999999",
      "poi_longitude": "-97.5666625",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-546-1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e484-706d-adf7-9c2b1828428c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e484-706d-adf7-9c2b1828428c",
        "storage_key": "property/6767906449165642/019d2709-e484-706d-adf7-9c2b1828428c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIS_1pD8bsocR7YyE6QFo9ZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_dd300abd-f1d4-448e-b878-ab7ead007e61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Quail Springs Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Shopping destination with a cinema, a food court, a kids' play area, and an arcade.",
      "poi_long_description": "People say this shopping center offers a variety of stores, a food court, a movie theater, and an arcade. They also highlight the fun atmosphere, the clean environment, and the good prices for the arcade and movies.\n\nOther reviews mention the food court can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-b6b5-7044-90b2-b209b5d8d3a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b6b5-7044-90b2-b209b5d8d3a2",
        "storage_key": "property/6767906449165642/019d2709-b6b5-7044-90b2-b209b5d8d3a2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.quailspringsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=254102542958583292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quail-springs-mall",
      "poi_latitude": "35.6130282",
      "poi_longitude": "-97.5584437",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-254-4979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e449-70ae-b9eb-036984d6bd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e449-70ae-b9eb-036984d6bd5a",
        "storage_key": "property/6767906449165642/019d2709-e449-70ae-b9eb-036984d6bd5a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR_N2RoerAhgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_d9f585c7-afa5-4632-9d8f-916607871aa8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3040 NW 59th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Large hardware chain stocked with a wide selection of tools, lumber and building materials, plus appliances.",
      "poi_long_description": "People say this home improvement store usually has what they need. They also highlight the staff is friendly and helpful.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-b58b-779a-8f23-8fb46fa9342e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b58b-779a-8f23-8fb46fa9342e",
        "storage_key": "property/6767906449165642/019d2709-b58b-779a-8f23-8fb46fa9342e.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/N-Oklahoma-City/OK/Oklahoma-City/73112/3902?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8923094349114202389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.5313564",
      "poi_longitude": "-97.5691642",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-843-5008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e449-70ae-b9eb-036984d6bd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e449-70ae-b9eb-036984d6bd5a",
        "storage_key": "property/6767906449165642/019d2709-e449-70ae-b9eb-036984d6bd5a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGSHGIfYasocRFVk_sAgz1Xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_0d8c8380-5a61-4132-ad13-59bede408225",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Home improvement chain with a wide selection of tools, appliances and paint for DIYers.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-b5a4-74ce-9542-42275074f486.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b5a4-74ce-9542-42275074f486",
        "storage_key": "property/6767906449165642/019d2709-b5a4-74ce-9542-42275074f486.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Oklahoma-City/0535?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-535-_-na-_-0-_-0&y_source=1_MTE4MzI1OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9854502234558219169&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.6067382",
      "poi_longitude": "-97.5561463",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-936-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e449-70ae-b9eb-036984d6bd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e449-70ae-b9eb-036984d6bd5a",
        "storage_key": "property/6767906449165642/019d2709-e449-70ae-b9eb-036984d6bd5a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ80ErRm8csocRocMiKZI5wog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_e6c8fd08-e36a-4c2a-b73b-3cecf34a565c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6410 N May Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Casual grocery chain selling organic, gluten-free and vegan foods, plus produce and packaged goods.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, organic foods, and healthy options. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-b98f-772a-8e9b-7e3e1843e1b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b98f-772a-8e9b-7e3e1843e1b5",
        "storage_key": "property/6767906449165642/019d2709-b98f-772a-8e9b-7e3e1843e1b5.webp",
        "width": 958,
        "height": 1280
      },
      "poi_business_url": "https://sprouts.com/store/ok/oklahoma-city/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=15265666738450826751&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.5374999",
      "poi_longitude": "-97.5647576",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-879-9989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e45e-73c8-8633-2078c1e68bde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e45e-73c8-8633-2078c1e68bde",
        "storage_key": "property/6767906449165642/019d2709-e45e-73c8-8633-2078c1e68bde.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSbEc1casocR_4XbhASL2tM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ff73e79e-afe2-49ba-b46d-4fa2d4a274a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "6100 N May Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Chain selling books and magazines, plus toys and gifts.",
      "poi_long_description": "People say this bookstore offers a huge selection of books, puzzles, music, and toys, and has a Starbucks. They highlight the clean, organized, and quiet atmosphere, and the friendly and helpful staff. They also like the convenient parking and the train table in the kids' section.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-ba37-7546-ba1c-8ded7272b2bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ba37-7546-ba1c-8ded7272b2bf",
        "storage_key": "property/6767906449165642/019d2709-ba37-7546-ba1c-8ded7272b2bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2694",
      "poi_directions_map_url": "https://maps.google.com/?cid=986591179468385464&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barnes--noble",
      "poi_latitude": "35.5331139",
      "poi_longitude": "-97.5647667",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-843-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e449-70ae-b9eb-036984d6bd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e449-70ae-b9eb-036984d6bd5a",
        "storage_key": "property/6767906449165642/019d2709-e449-70ae-b9eb-036984d6bd5a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvczS4lgasocRuCy_VnMTsQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_c9af0371-cb8f-47f9-95d3-c84ec9f920fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Southern Nazarene University",
      "poi_type": "Education",
      "poi_address": "6729 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-bb39-757b-9ca6-007e336575a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bb39-757b-9ca6-007e336575a1",
        "storage_key": "property/6767906449165642/019d2709-bb39-757b-9ca6-007e336575a1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2990625230431240297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-nazarene-university",
      "poi_latitude": "35.5135594",
      "poi_longitude": "-97.6288124",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-789-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e4c0-7789-94b3-cab00b05ab54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e4c0-7789-94b3-cab00b05ab54",
        "storage_key": "property/6767906449165642/019d2709-e4c0-7789-94b3-cab00b05ab54.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHYsS70IFsocRacAsVM3VgCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a5f4975f-87cd-4a51-b838-4aa5a99f3918",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Patience S. Latting Northwest Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "5600 NW 122nd St, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Modern, welcoming library featuring kid-friendly activities and patios, plus a large selection of books.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-bb5d-721b-8e78-139c3f1a7e52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bb5d-721b-8e78-139c3f1a7e52",
        "storage_key": "property/6767906449165642/019d2709-bb5d-721b-8e78-139c3f1a7e52.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6566230327670178026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "patience-s-latting-northwest-library---metropolitan-library-system",
      "poi_latitude": "35.5941759",
      "poi_longitude": "-97.6179217",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-606-3580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e4c0-7789-94b3-cab00b05ab54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e4c0-7789-94b3-cab00b05ab54",
        "storage_key": "property/6767906449165642/019d2709-e4c0-7789-94b3-cab00b05ab54.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkacMZVEDsocR6oAtkrHvH1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_aae3b6ea-a155-41c5-a414-caa8ed4a948a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "The Village Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "10307 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Public library featuring DVDs and quiet areas for study and reading.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-be66-7272-b5bc-914c379f5d5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-be66-7272-b5bc-914c379f5d5d",
        "storage_key": "property/6767906449165642/019d2709-be66-7272-b5bc-914c379f5d5d.webp",
        "width": 1280,
        "height": 382
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6591062255135426801&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-village-library---metropolitan-library-system",
      "poi_latitude": "35.5755065",
      "poi_longitude": "-97.5498468",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-755-0710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e4c0-7789-94b3-cab00b05ab54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e4c0-7789-94b3-cab00b05ab54",
        "storage_key": "property/6767906449165642/019d2709-e4c0-7789-94b3-cab00b05ab54.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt5LnnJMbsocR8QjVOTMoeFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_bbbb107f-a0eb-4ff6-ba5e-f3579ae7f250",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Blue Zoo Aquarium Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite 125A, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Mall-based attraction featuring sharks, stingrays, snakes and other marine life plus a playground for kids.",
      "poi_long_description": "People say this aquarium offers a variety of interactive experiences, including stingray petting and feeding, bird feeding, and a mermaid show. They also highlight the family-friendly atmosphere, the friendly and helpful staff, and the fun play area for children.\n\nSome reviews mention the aquarium can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-bfac-721d-843e-b1b4cdc0c0b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bfac-721d-843e-b1b4cdc0c0b8",
        "storage_key": "property/6767906449165642/019d2709-bfac-721d-843e-b1b4cdc0c0b8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oklahomacity.bluezoo.us/?utm_source=google&utm_medium=organic&utm_campaign=Google+Business+Profile+-+OKC",
      "poi_directions_map_url": "https://maps.google.com/?cid=5242468447430833348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-zoo-aquarium-oklahoma-city",
      "poi_latitude": "35.6125884",
      "poi_longitude": "-97.5573925",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 208-912-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4zKmxcdsocRxPRO80b9wEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_a1a4b401-dfc7-45cc-b5d2-acca16e34732",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "SNU Football Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Bethany, OK 73008, USA",
      "poi_short_description": "Stadium offering a field and a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-c0b7-765d-af33-5a1b0fd5e1e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c0b7-765d-af33-5a1b0fd5e1e1",
        "storage_key": "property/6767906449165642/019d2709-c0b7-765d-af33-5a1b0fd5e1e1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://snuathletics.com/facilities/snu-football-stadium/1",
      "poi_directions_map_url": "https://maps.google.com/?cid=14871021148287990153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "snu-football-stadium",
      "poi_latitude": "35.5210386",
      "poi_longitude": "-97.661832",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e860-7381-8242-55d82eccafa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e860-7381-8242-55d82eccafa8",
        "storage_key": "property/6767906449165642/019d2709-e860-7381-8242-55d82eccafa8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFyihiaEFsocRifkGv_F6YM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_888e6c9d-5fda-4c18-b7f0-0442a13b3fff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Oklahoma Museum of Flying",
      "poi_type": "Entertainment",
      "poi_address": "7110 Millionaire Dr, Bethany, OK 73008, USA",
      "poi_short_description": "Volunteer-powered locale for seeing and touching real planes plus learning about their history and mechanics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-c048-707e-9c44-1053cfa63908.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c048-707e-9c44-1053cfa63908",
        "storage_key": "property/6767906449165642/019d2709-c048-707e-9c44-1053cfa63908.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/oklahomamuseumofflying/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7234880537762503548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-museum-of-flying",
      "poi_latitude": "35.5337967",
      "poi_longitude": "-97.6380221",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e960-7721-b852-2b4c2a22238c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e960-7721-b852-2b4c2a22238c",
        "storage_key": "property/6767906449165642/019d2709-e960-7721-b852-2b4c2a22238c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5c3VjhkFsocRfJu4XYR1Z2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_05fe6e8d-17b1-42a5-8296-65c8747aa536",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Pirate Stadium",
      "poi_type": "Entertainment",
      "poi_address": "5300 NW 50th St, Oklahoma City, OK 73122, USA",
      "poi_short_description": "Venue used for graduation, track meets, and games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-c310-748d-8108-90aeb26b1d50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c310-748d-8108-90aeb26b1d50",
        "storage_key": "property/6767906449165642/019d2709-c310-748d-8108-90aeb26b1d50.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://stadiumconnection.com/ok/stadium.php?id=2852",
      "poi_directions_map_url": "https://maps.google.com/?cid=11523176646670315445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pirate-stadium",
      "poi_latitude": "35.5216132",
      "poi_longitude": "-97.6066534",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-789-7101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e860-7381-8242-55d82eccafa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e860-7381-8242-55d82eccafa8",
        "storage_key": "property/6767906449165642/019d2709-e860-7381-8242-55d82eccafa8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR1OWhrUasocRtW_clBuM6p8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_2e4b4966-f3c0-4393-9f82-75cb877e3c2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Herrick Building and Auditorium - SNU",
      "poi_type": "Entertainment",
      "poi_address": "6749 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-c407-771a-be31-e8de60f3c780.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c407-771a-be31-e8de60f3c780",
        "storage_key": "property/6767906449165642/019d2709-c407-771a-be31-e8de60f3c780.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15681811452994641819&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "herrick-building-and-auditorium---snu",
      "poi_latitude": "35.5123354",
      "poi_longitude": "-97.6304674",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4dCV-0IFsocRm99lQm78oNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_0b8de2c3-f6b5-4a3d-88e7-5715993dc420",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "2563 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers excellent tennis courts. They also highlight the facility has many pools and pickleball courts.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-c4e9-728b-af65-b1d68d5d7778.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c4e9-728b-af65-b1d68d5d7778",
        "storage_key": "property/6767906449165642/019d2709-c4e9-728b-af65-b1d68d5d7778.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/oklahoma-city.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=13614994550085944548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "35.61423510000001",
      "poi_longitude": "-97.5602129",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-832-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWAnM3kdsocR5ITAcGgt8rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a88408a2-ea5a-427e-858b-1b19bb0c8f9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of group fitness classes, modern equipment, and childcare, and has a friendly and motivating atmosphere.\n\nOther reviews mention membership cancellation can be difficult and there can be hidden fees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-c598-7563-ac5e-f7c4f74f6a3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c598-7563-ac5e-f7c4f74f6a3e",
        "storage_key": "property/6767906449165642/019d2709-c598-7563-ac5e-f7c4f74f6a3e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city-ok",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_90e0ab37-e79f-4ebf-9952-db7f6574fcaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Crunch Fitness - OKC Northwest",
      "poi_type": "Health and Wellness",
      "poi_address": "8490 Northwest Expy, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, weight machines, and tanning beds, and provides childcare services.\n\nOther reviews mention the music can be loud and the cancellation policy can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-c78c-70ba-9377-f5350a31f962.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c78c-70ba-9377-f5350a31f962",
        "storage_key": "property/6767906449165642/019d2709-c78c-70ba-9377-f5350a31f962.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/okc-northwest",
      "poi_directions_map_url": "https://maps.google.com/?cid=6916258324870179385&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---okc-northwest",
      "poi_latitude": "35.56632099999999",
      "poi_longitude": "-97.6628647",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-267-6282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWtxzOQFsocROaq5dE18-18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dd86fd27-d560-4606-bda0-673d060216f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "TB Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-c85b-7326-9876-bf236150bd4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c85b-7326-9876-bf236150bd4c",
        "storage_key": "property/6767906449165642/019d2709-c85b-7326-9876-bf236150bd4c.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fitness-club",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7a5427b5-4b0c-460b-b3ac-4949156dc5c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "2340 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Beauty retailer offering cosmetics, fragrances, and skin and hair care products, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-c8f3-73da-8300-e8399d8f5846.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c8f3-73da-8300-e8399d8f5846",
        "storage_key": "property/6767906449165642/019d2709-c8f3-73da-8300-e8399d8f5846.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/oklahoma-city-ok-128",
      "poi_directions_map_url": "https://maps.google.com/?cid=17751417342740012859&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.606929",
      "poi_longitude": "-97.553605",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-302-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmaQHR2kcsocROx-6rQW0WfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_6719d2fb-0a2c-4d6a-80e7-97cfdc70d252",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Scissors & Scotch",
      "poi_type": "Health and Wellness",
      "poi_address": "13230 Pawnee Dr #202, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Upscale barber shop for beard trims and straight-razor shaves alongside a private lounge and a full bar with whisky. Waxing, manicures and massages are also offered.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-c9af-7618-819c-096d90f560c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c9af-7618-819c-096d90f560c2",
        "storage_key": "property/6767906449165642/019d2709-c9af-7618-819c-096d90f560c2.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://scissorsscotch.com/locations/ok/oklahoma-city/chisholm-creek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17460232672315201299&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scissors--scotch",
      "poi_latitude": "35.60419",
      "poi_longitude": "-97.5337642",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-486-4902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62z3xRocsocRE1cEcRs1T_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_87b0984f-c0d1-49c4-83d3-8be896347960",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10908 N May Ave A, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Spacious gym with a hydro-massage area and tanning beds, plus classes and machines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-cc35-70f8-8399-af424f74345b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cc35-70f8-8399-af424f74345b",
        "storage_key": "property/6767906449165642/019d2709-cc35-70f8-8399-af424f74345b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oklahoma-city-quail-plaza-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3477844169655460775&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.5807984",
      "poi_longitude": "-97.5653315",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-697-1750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXhK4IIbsocRpyN6jNjIQzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dcf9adf2-155c-4a8b-bcd7-122f271f641b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Four Star Fitness - Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "7013 N May Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Spacious gym featuring weights and cardio equipment, plus personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including dumbbells over 120lbs, Hammer Strength, and Atlantis equipment. They highlight the clean facilities and friendly, helpful staff. They also like the serious and respectful workout environment. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-cd5f-71cc-ab56-b3282e08f23a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cd5f-71cc-ab56-b3282e08f23a",
        "storage_key": "property/6767906449165642/019d2709-cd5f-71cc-ab56-b3282e08f23a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fourstarfitnessokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050931711802974728&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "four-star-fitness---oklahoma-city",
      "poi_latitude": "35.54217879999999",
      "poi_longitude": "-97.5664473",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-418-4496",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK6JthFYasocRCKJ1Ww0Uoew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9cf2ecf0-f1df-4ab6-bb58-97fcaaa09afb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Rockwell Plaza YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8300 Glade Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Clean gym with a basketball court.",
      "poi_long_description": "People say this gym offers a pool and a variety of fitness equipment.\n\nOther reviews mention the staff can be unhelpful and the rules can be strict.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-cd1d-74bd-a7e3-f71c5897b05d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cd1d-74bd-a7e3-f71c5897b05d",
        "storage_key": "property/6767906449165642/019d2709-cd1d-74bd-a7e3-f71c5897b05d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcaokc.org/branches/rockwell-plaza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17719347020841965419&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rockwell-plaza-ymca",
      "poi_latitude": "35.5546582",
      "poi_longitude": "-97.6422942",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-621-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJleKdJ_AEsocRa1cp_TvE5_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2873683b-13c2-4a28-91c8-83654cbb6fb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "INTEGRIS Health Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-cee8-74b0-9470-ac06587371f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cee8-74b0-9470-ac06587371f1",
        "storage_key": "property/6767906449165642/019d2709-cee8-74b0-9470-ac06587371f1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baptist.integrisok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369483754313068495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-baptist-medical-center",
      "poi_latitude": "35.5290386",
      "poi_longitude": "-97.5764421",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-949-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8e8-704b-ac6c-f0ce481fa641.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8e8-704b-ac6c-f0ce481fa641",
        "storage_key": "property/6767906449165642/019d2709-e8e8-704b-ac6c-f0ce481fa641.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX5SM_IasocRz68D4IjO548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_50af9fba-b3d5-49aa-939d-3314cc5993cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-d06b-7356-98e4-b9f831078a08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d06b-7356-98e4-b9f831078a08",
        "storage_key": "property/6767906449165642/019d2709-d06b-7356-98e4-b9f831078a08.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTI5OTY2MDItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313836111055257082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city",
      "poi_latitude": "35.607198",
      "poi_longitude": "-97.600529",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-755-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8e8-704b-ac6c-f0ce481fa641.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8e8-704b-ac6c-f0ce481fa641",
        "storage_key": "property/6767906449165642/019d2709-e8e8-704b-ac6c-f0ce481fa641.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-YSHLkcsocR-n2nn5hkQYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a79057b8-b76c-4b47-b8b1-71217bb80e01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Martin Park Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Kid-friendly nature preserve with playgrounds and trails, plus deer and turtles.",
      "poi_long_description": "People say this park offers beautiful trails, a playground, and opportunities to see wildlife like deer, turtles, and birds. They highlight the serene and peaceful atmosphere, and the well-maintained grounds. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-d1b9-77cd-a588-6ee15907aa94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d1b9-77cd-a588-6ee15907aa94",
        "storage_key": "property/6767906449165642/019d2709-d1b9-77cd-a588-6ee15907aa94.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/martin-park-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715724291787303274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-park-nature-center",
      "poi_latitude": "35.6090059",
      "poi_longitude": "-97.6090052",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-297-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-ec02-76da-b2de-d75c546cb7e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ec02-76da-b2de-d75c546cb7e4",
        "storage_key": "property/6767906449165642/019d2709-ec02-76da-b2de-d75c546cb7e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71CwarQcsocRaqmda8Qv1YY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f3108c36-3753-40d7-a5e5-051219e3f5fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Stars And Stripes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3701 S Lake Hefner Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Relaxed, family-friendly park bordering Lake Hefner offering a skatepark, plus playgrounds.",
      "poi_long_description": "People say this city park offers a large playground, walking trails, and panoramic views of the lake. They highlight the numerous play areas, tables, and BBQ spaces, as well as the decent parking and proximity to the lake. They also like the ability to build sandcastles and watch boats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-d2cd-7015-8899-700a712281d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d2cd-7015-8899-700a712281d4",
        "storage_key": "property/6767906449165642/019d2709-d2cd-7015-8899-700a712281d4.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/34/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=16012526237037472583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stars-and-stripes-park",
      "poi_latitude": "35.5500436",
      "poi_longitude": "-97.5822759",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-ec02-76da-b2de-d75c546cb7e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ec02-76da-b2de-d75c546cb7e4",
        "storage_key": "property/6767906449165642/019d2709-ec02-76da-b2de-d75c546cb7e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2tmaBwbsocRR6s9S8brN94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5a04c523-7de8-44e1-8ea0-ca9b4fcb0337",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Bluff Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11301 N Meridian Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "A large green space featuring walking trails, picnic spots and a playground.",
      "poi_long_description": "Visitors say this park offers well-maintained walking trails, paved trails, and bike trails, and they praise the abundance of wildlife, especially deer. They also highlight the peaceful atmosphere, ideal for nature walks, jogging, or simply relaxing in the outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-d573-7457-abe3-04c835de05f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d573-7457-abe3-04c835de05f2",
        "storage_key": "property/6767906449165642/019d2709-d573-7457-abe3-04c835de05f2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/8/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=1559565554729670411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluff-creek-park",
      "poi_latitude": "35.584442",
      "poi_longitude": "-97.6065873",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-837-7995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-ec02-76da-b2de-d75c546cb7e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ec02-76da-b2de-d75c546cb7e4",
        "storage_key": "property/6767906449165642/019d2709-ec02-76da-b2de-d75c546cb7e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3zaRlYbsocRC9eY7ZuwpBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e21582eb-0b8b-4b46-9c52-1cf3528c78fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Rose Creek Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17031 N May Ave, Edmond, OK 73012, USA",
      "poi_short_description": "Private golf course with an on-site eatery, pickleball courts, a clubhouse and a patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-d5d2-76dc-89bf-612e73d8fa59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d5d2-76dc-89bf-612e73d8fa59",
        "storage_key": "property/6767906449165642/019d2709-d5d2-76dc-89bf-612e73d8fa59.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rosecreekgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14897560691660009268&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-creek-country-club",
      "poi_latitude": "35.6449907",
      "poi_longitude": "-97.5686808",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-330-8220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-ecca-7068-863a-38da32502f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ecca-7068-863a-38da32502f3c",
        "storage_key": "property/6767906449165642/019d2709-ecca-7068-863a-38da32502f3c.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8IOAwgdsocRNK83toTEvs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_09b3c8bd-739f-4177-a6e7-f3d02d763328",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Dolese Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5105 NW 50th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Park with picnic tables, a playground, a paved cycling trail, disc golf course, and facilities for baseball and fishing.",
      "poi_long_description": "People say this park offers a disc golf course, trails, a playground, and a pond for fishing. They highlight the beautiful scenery, the well-maintained trails, and the friendly people. They also like the calming atmosphere and the ample space for various activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-d6f3-776b-a77c-32c4571511fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d6f3-776b-a77c-32c4571511fa",
        "storage_key": "property/6767906449165642/019d2709-d6f3-776b-a77c-32c4571511fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15736370327146326173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dolese-park",
      "poi_latitude": "35.52624369999999",
      "poi_longitude": "-97.6055628",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-ec02-76da-b2de-d75c546cb7e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ec02-76da-b2de-d75c546cb7e4",
        "storage_key": "property/6767906449165642/019d2709-ec02-76da-b2de-d75c546cb7e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcf9-e8kasocRneiNC3DRYto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cf776fa9-7ba6-40ba-9376-ad4d74667c27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Wiley Post Airport-PWA",
      "poi_type": "Transportation & Transit",
      "poi_address": "5915 Philip J Rhoads Ave, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-d78c-7471-a39c-c6e3c9661762.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d78c-7471-a39c-c6e3c9661762",
        "storage_key": "property/6767906449165642/019d2709-d78c-7471-a39c-c6e3c9661762.webp",
        "width": 1280,
        "height": 1013
      },
      "poi_business_url": "http://www.wileypostairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17919166834402155680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wiley-post-airport-pwa",
      "poi_latitude": "35.5307445",
      "poi_longitude": "-97.6430208",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-316-4061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-ed27-75c4-8625-2dc4129c9b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed27-75c4-8625-2dc4129c9b02",
        "storage_key": "property/6767906449165642/019d2709-ed27-75c4-8625-2dc4129c9b02.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0-vGAMFsocRoFyAy0urrfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_75be6345-2bb5-4c46-a451-64e504fab527",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Sundance Airport KHSD",
      "poi_type": "Transportation & Transit",
      "poi_address": "13000 N Sara Rd, Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-da77-75d0-baa8-cb61d78f75d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-da77-75d0-baa8-cb61d78f75d9",
        "storage_key": "property/6767906449165642/019d2709-da77-75d0-baa8-cb61d78f75d9.webp",
        "width": 1280,
        "height": 478
      },
      "poi_business_url": "http://sundanceairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335938299321620831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sundance-airport-khsd",
      "poi_latitude": "35.601503",
      "poi_longitude": "-97.7069306",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-373-3886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-ed27-75c4-8625-2dc4129c9b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed27-75c4-8625-2dc4129c9b02",
        "storage_key": "property/6767906449165642/019d2709-ed27-75c4-8625-2dc4129c9b02.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6eH4NUUBsocRX5nnHM40ihI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_dc3252db-2906-4004-b565-3ee7282d33d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Jetset FBO",
      "poi_type": "Transportation & Transit",
      "poi_address": "7220 NW 63rd St, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-da88-7007-a531-87c2d004b9d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-da88-7007-a531-87c2d004b9d8",
        "storage_key": "property/6767906449165642/019d2709-da88-7007-a531-87c2d004b9d8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.jetsetfbo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=522519284200811341&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jetset-fbo",
      "poi_latitude": "35.5368188",
      "poi_longitude": "-97.6412624",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-888-8684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-ed27-75c4-8625-2dc4129c9b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ed27-75c4-8625-2dc4129c9b02",
        "storage_key": "property/6767906449165642/019d2709-ed27-75c4-8625-2dc4129c9b02.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1b0wrcFsocRTasUQ4VcQAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_d9a15b3d-d92b-42e2-81ee-8e44edf904ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Costco Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14501 Bogert Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-dcd2-76e9-8c6f-ca7b562d4f2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-dcd2-76e9-8c6f-ca7b562d4f2d",
        "storage_key": "property/6767906449165642/019d2709-dcd2-76e9-8c6f-ca7b562d4f2d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497496067160567460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "costco-member-service-center",
      "poi_latitude": "35.6183037",
      "poi_longitude": "-97.5748651",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX18i7nkdsocRpG5ufiSaiTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_51bb24a7-7109-481b-87a4-0f052784b161",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-dc41-7327-9637-80c247f78d31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-dc41-7327-9637-80c247f78d31",
        "storage_key": "property/6767906449165642/019d2709-dc41-7327-9637-80c247f78d31.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0994518c-aae1-4192-85e0-23145acbd2b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Express Employment International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9701 Boardwalk Blvd, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-df6a-74eb-bfc5-827ed4f3ad7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-df6a-74eb-bfc5-827ed4f3ad7f",
        "storage_key": "property/6767906449165642/019d2709-df6a-74eb-bfc5-827ed4f3ad7f.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.expresspros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=92586903052956857&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "express-employment-international",
      "poi_latitude": "35.56707",
      "poi_longitude": "-97.666693",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-840-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6z8UW8EsocRuTRTO0zvSAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5b4911e8-8c65-47b3-9179-da92f53bee37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Love's Corporate - Building 50",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3601 NW 63rd St, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-df63-778c-bfe4-d7b673563f2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-df63-778c-bfe4-d7b673563f2f",
        "storage_key": "property/6767906449165642/019d2709-df63-778c-bfe4-d7b673563f2f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4599439798442847940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---building-50",
      "poi_latitude": "35.5374849",
      "poi_longitude": "-97.5809021",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8bq4uQasocRxO76tyB-1D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_40a7636d-3e51-4ea5-901c-e25a31b912cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Love's Corporate - Contact Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1331 W Memorial Rd Suite 100, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e068-76ae-989c-7480c0cfb6d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e068-76ae-989c-7480c0cfb6d5",
        "storage_key": "property/6767906449165642/019d2709-e068-76ae-989c-7480c0cfb6d5.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "http://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980310977560095404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---contact-center",
      "poi_latitude": "35.61081310000001",
      "poi_longitude": "-97.5351028",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e8a1-7248-820f-85e3b7125205",
        "storage_key": "property/6767906449165642/019d2709-e8a1-7248-820f-85e3b7125205.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKbub2xkcsocRrKpygHKeHUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7b55831f-8765-4885-8110-dad314abd32a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Putnam City North High School",
      "poi_type": "Education",
      "poi_address": "11800 N Rockwell Ave, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-c158-7599-bcd0-f0945ba17814.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c158-7599-bcd0-f0945ba17814",
        "storage_key": "property/6767906449165642/019d7913-c158-7599-bcd0-f0945ba17814.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://pcnorth.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10895318835090211107&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "putnam-city-north-high-school",
      "poi_latitude": "35.5891349",
      "poi_longitude": "-97.6368418",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-722-4220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7df3-71cc-a209-ceb58887a610",
        "storage_key": "property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-ZkjjmADsocRI8EsMMHyM5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_89479ba4-21f6-4f36-bad2-eb4d43f3c5f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Hefner Middle School",
      "poi_type": "Education",
      "poi_address": "8400 N MacArthur Blvd, Oklahoma City, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-c036-706f-8bc8-3d049a76a58d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c036-706f-8bc8-3d049a76a58d",
        "storage_key": "property/6767906449165642/019d7913-c036-706f-8bc8-3d049a76a58d.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://hefner.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3061661222022488476&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hefner-middle-school",
      "poi_latitude": "35.557427",
      "poi_longitude": "-97.6193703",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-721-2411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7df3-71cc-a209-ceb58887a610",
        "storage_key": "property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsWfEvs8EsocRnCE9-ag0fSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f8f9cc89-9920-4593-9896-bbc2da4d2877",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "James L. Dennis Elementary",
      "poi_type": "Education",
      "poi_address": "11800 James L Dennis Dr, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://dennis.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11960917566250256721&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "james-l-dennis-elementary",
      "poi_latitude": "35.5889218",
      "poi_longitude": "-97.6308249",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-722-6510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7df3-71cc-a209-ceb58887a610",
        "storage_key": "property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA_VMkl8DsocRUYkTpCe3_aU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_4b991b1e-ef6d-4f7f-a318-9727a50022a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Oklahoma City University",
      "poi_type": "Education",
      "poi_address": "2501 N Blackwelder Ave, Oklahoma City, OK 73106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-c066-74ad-ade9-53dd8f314067.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c066-74ad-ade9-53dd8f314067",
        "storage_key": "property/6767906449165642/019d7913-c066-74ad-ade9-53dd8f314067.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=411899583880737593&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-university",
      "poi_latitude": "35.4954082",
      "poi_longitude": "-97.540768",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-208-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7df3-71cc-a209-ceb58887a610",
        "storage_key": "property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe7zZY6MQsocRObNXPH1ctwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_be6de5eb-95ee-441d-879a-ff77802ebb49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Casady School",
      "poi_type": "Education",
      "poi_address": "9500 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-c075-7046-9a02-5a2d17566ae8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c075-7046-9a02-5a2d17566ae8",
        "storage_key": "property/6767906449165642/019d7913-c075-7046-9a02-5a2d17566ae8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.casady.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9825637108673764104&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "casady-school",
      "poi_latitude": "35.568469",
      "poi_longitude": "-97.546406",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-749-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7df3-71cc-a209-ceb58887a610",
        "storage_key": "property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP8HoKJUbsocRCFtlUuSsW4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_370d2fda-6a20-4b9d-903f-21d839c97263",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Deer Creek Intermediate School",
      "poi_type": "Education",
      "poi_address": "4800 NW 206th St, Edmond, OK 73012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://dcis.deercreekschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6814190818379472131&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "deer-creek-intermediate-school",
      "poi_latitude": "35.6805391",
      "poi_longitude": "-97.6051271",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-531-9328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7df3-71cc-a209-ceb58887a610",
        "storage_key": "property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBxqUNyH3sYcRA508OXLekF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_7922c797-f88e-4aff-a86a-7ba8039f0b31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "West Field Elementary School",
      "poi_type": "Education",
      "poi_address": "17601 N Pennsylvania Ave, Edmond, OK 73012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-c866-7188-aa7d-1213d2cb9ba6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c866-7188-aa7d-1213d2cb9ba6",
        "storage_key": "property/6767906449165642/019d7913-c866-7188-aa7d-1213d2cb9ba6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://westfield.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4083049404551104633&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "west-field-elementary-school",
      "poi_latitude": "35.6504509",
      "poi_longitude": "-97.5509661",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-340-2285",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7df3-71cc-a209-ceb58887a610",
        "storage_key": "property/6767906449165642/019cfb4c-7df3-71cc-a209-ceb58887a610.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv8RJJLkdsocReYij7sznqTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_17790bd8-4cb1-4065-943a-cfb326954057",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "The Garage Burgers & Beer",
      "poi_type": "Restaurants",
      "poi_address": "6900 NW 122nd St, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Trendy bar with TV sports & games, known for inventive gourmet burgers, tacos & hot dogs.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, including bison burgers, and loaded queso. They also highlight the fun atmosphere, decent beer selection, and attentive staff.\n\nSome reviews mention the orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-c727-74be-a683-d1a9f1832a14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c727-74be-a683-d1a9f1832a14",
        "storage_key": "property/6767906449165642/019d7913-c727-74be-a683-d1a9f1832a14.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "http://eatatthegarage.com/locations/the-garage-rockwell/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7470076178638343110&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-garage-burgers-beer",
      "poi_latitude": "35.5941438",
      "poi_longitude": "-97.6367409",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-603-3080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-47a19ec59783",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZwMGVGYDsocRxovY0LQKq2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_dc6f6ac6-7eca-4cd3-8b5b-9cc9ac15777f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Hideaway Pizza",
      "poi_type": "Restaurants",
      "poi_address": "5950 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_long_description": "People say this pizza restaurant serves delicious pizza with a variety of toppings and crust options, as well as appetizers like garlic knots and fried mushrooms. They highlight the fun, nostalgic atmosphere and the reasonable prices. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-c747-7088-aa2d-9f59e7d99e22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c747-7088-aa2d-9f59e7d99e22",
        "storage_key": "property/6767906449165642/019d7913-c747-7088-aa2d-9f59e7d99e22.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hideawaypizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7905621766239886332&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hideaway-pizza",
      "poi_latitude": "35.6080676",
      "poi_longitude": "-97.6240676",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-470-4777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-47a19ec59783",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRYspIEgDsocR_BtTURxptm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_d7d88730-d033-4593-81ac-ada6b84e7ad4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Abel's Méxican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5822 NW 50th St, Warr Acres, OK 73122, USA",
      "poi_short_description": "Basic Tex-Mex dishes, along with traditional Mexican fare, are the draw at this colorful taqueria.",
      "poi_long_description": "People say this Mexican restaurant serves flavorful Tex-Mex food with generous portions and a variety of homemade salsas. They also highlight the friendly staff, comfortable atmosphere, and good value.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-c963-7007-bdee-c22b845d0f9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c963-7007-bdee-c22b845d0f9d",
        "storage_key": "property/6767906449165642/019d7913-c963-7007-bdee-c22b845d0f9d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://abelsmexicanrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1938917354506844673&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "abel-s-m-xican-restaurant",
      "poi_latitude": "35.52193159999999",
      "poi_longitude": "-97.6170145",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-491-0911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-47a19ec59783",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDb2wHDYFsocRAXo4pA9r6Bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_048b2c63-5209-4eb9-9deb-624ef1f74820",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Birriería Diaz",
      "poi_type": "Restaurants",
      "poi_address": "6700 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "Unpretentious corner outpost serving a range of Mexican standards such as tacos & enchiladas.",
      "poi_long_description": "People say this Mexican restaurant serves delicious birria tacos, carne asada, and enchiladas. They highlight the authentic, home-style ranchero atmosphere and the fresh, flavorful salsa, queso dip, and bean appetizer. They also like the friendly staff and the generous portions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-ce8c-7258-80ab-cc579771c734.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ce8c-7258-80ab-cc579771c734",
        "storage_key": "property/6767906449165642/019d7913-ce8c-7258-80ab-cc579771c734.webp",
        "width": 720,
        "height": 406
      },
      "poi_business_url": "https://birrieria-diaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9453469059150246300&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "birrier-a-diaz",
      "poi_latitude": "35.5112999",
      "poi_longitude": "-97.629274",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-603-1304",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-47a19ec59783",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0XjnOUMFsocRnPHLzQV4MYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_142b482c-bdff-4184-a4cf-197c5a5d9783",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Eggceptional Cafe",
      "poi_type": "Restaurants",
      "poi_address": "6210 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Homemade breakfast fare (waffles and burritos included) plus lunch items at a relaxed cafe with a covered patio.",
      "poi_long_description": "People say this breakfast restaurant serves delicious cinnamon rolls, waffles, and chicken fried steak. They highlight the generous portions, reasonable prices, and cozy, homey atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-d249-7546-84e6-b281df4abd13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d249-7546-84e6-b281df4abd13",
        "storage_key": "property/6767906449165642/019d7913-d249-7546-84e6-b281df4abd13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sites.google.com/eggceptionalcafe.net/eggceptionalcafe/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=8294575730068253181&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eggceptional-cafe",
      "poi_latitude": "35.5517873",
      "poi_longitude": "-97.626062",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-730-6462",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-47a19ec59783",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH0-GE4oFsocR_WlLEa5AHHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_68446e94-8736-4dd9-ab14-426fa3e0b90b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "The Press",
      "poi_type": "Restaurants",
      "poi_address": "1610 N Gatewood Ave, Oklahoma City, OK 73106, USA",
      "poi_short_description": "Warm, brick-exposed eatery offering American plates & comfort fare plus a full bar with cocktails.",
      "poi_long_description": "People say this restaurant serves delicious New Mexico-style food, including green chile soup, fried bread tacos, and chicken fried ribeye. They highlight the generous portions, reasonable prices, and cozy, relaxed vibe, especially on the patio. They also like the friendly, attentive, and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-d587-727a-b701-76ee1f54debd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d587-727a-b701-76ee1f54debd",
        "storage_key": "property/6767906449165642/019d7913-d587-727a-b701-76ee1f54debd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thepressokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5078440206507297195&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-press",
      "poi_latitude": "35.4853791",
      "poi_longitude": "-97.5395331",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 23 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 405-208-7739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-47a19ec59783",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCeyB6LgQsocRq8ntCXY-ekY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b92dee2c-d459-4334-b331-010ce2a47d3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Sunnyside Diner",
      "poi_type": "Restaurants",
      "poi_address": "9148 N MacArthur Blvd, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Sunny, family-owned venue serving comfort food with vegan options, including popular cinnamon rolls.",
      "poi_long_description": "Diners say this diner serves up delicious cinnamon rolls, pancakes, and breakfast burritos, and they praise the friendly and attentive service. They also highlight the diner's reasonable prices and pleasant atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-d579-7747-9b7e-ba5d670d3fb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d579-7747-9b7e-ba5d670d3fb3",
        "storage_key": "property/6767906449165642/019d7913-d579-7747-9b7e-ba5d670d3fb3.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://eatatsunnyside.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8360246992459314393&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sunnyside-diner",
      "poi_latitude": "35.5638042",
      "poi_longitude": "-97.620361",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-722-8262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-47a19ec59783",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYhFRsgEsocR2bQQXFiQBXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_8cbb1a14-232f-4752-9431-96afc5d4f88e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Paseo Grill",
      "poi_type": "Restaurants",
      "poi_address": "2909 Paseo, Oklahoma City, OK 73103, USA",
      "poi_short_description": "Romantic restaurant with a streetside patio serving gourmet American fare & fine wines.",
      "poi_long_description": "People say this restaurant serves delicious mushroom soup, grilled chicken, and surf and turf. They highlight the romantic atmosphere, cozy private tables, and attentive service. They also like the generous portions of alcohol in the cocktails and the complimentary fruit and house-made whipped cream.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-d5d0-744a-92da-8c8e696d1580.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d5d0-744a-92da-8c8e696d1580",
        "storage_key": "property/6767906449165642/019d7913-d5d0-744a-92da-8c8e696d1580.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.paseogrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14700858340821713894&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "paseo-grill",
      "poi_latitude": "35.4986873",
      "poi_longitude": "-97.5223275",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-601-1079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-47a19ec59783",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI1COB1MXsocR5kMEwsXwA8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a2ce2fd0-973c-4d5e-83a2-c529ecaf4d4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "The Metro Wine Bar & Bistro",
      "poi_type": "Restaurants",
      "poi_address": "6418 N Western Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "A cozy dimly lit establishment featuring French-inspired cuisine, cocktails & 400+ wines.",
      "poi_long_description": "People say this restaurant offers delicious dishes like parmesan risotto, mushroom ravioli, and cedar-planked salmon, as well as thoughtfully crafted mocktails and expertly paired wine flights. They highlight the sophisticated yet comfortable ambiance, perfect for special occasions or a relaxing night out. They also like the attentive, knowledgeable, and welcoming service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-da2b-7738-b3d5-8a659790b62b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-da2b-7738-b3d5-8a659790b62b",
        "storage_key": "property/6767906449165642/019d7913-da2b-7738-b3d5-8a659790b62b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrowinebar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12574017624860625019&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-metro-wine-bar-bistro",
      "poi_latitude": "35.5376496",
      "poi_longitude": "-97.5293252",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-840-9463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-47a19ec59783",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TqhDCYasocRe4hR6Wjif64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_94a83f2d-1084-489d-9e0e-ac557d447c4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Cheever's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2409 N Hudson Ave, Oklahoma City, OK 73103, USA",
      "poi_short_description": "Elegant bistro offering upscale Southwestern & Southern cuisine plus cocktails & wines.",
      "poi_long_description": "People say this restaurant serves delicious chicken fried steak, crab cakes, and carrot cake. They highlight the generous portions, fair prices, and cozy, fine-dining atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-dc15-75ed-96a1-ebd879df6919.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-dc15-75ed-96a1-ebd879df6919",
        "storage_key": "property/6767906449165642/019d7913-dc15-75ed-96a1-ebd879df6919.webp",
        "width": 1246,
        "height": 816
      },
      "poi_business_url": "http://www.cheeverscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=217247908140213911&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cheever-s-cafe",
      "poi_latitude": "35.4937158",
      "poi_longitude": "-97.5190475",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 29 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-525-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-47a19ec59783",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5w0nd04XsocRl-bkSNLRAwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_69609bdc-6a94-4ffe-abd8-16deab007b63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "11120 N Rockwell Ave, Oklahoma City, OK 73162, USA",
      "poi_short_description": "Grocery store offering a good selection of produce, meat, and deli items.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, quality meats, and specialty items, and has a good deli and bakery. They also highlight the competitive prices, frequent sales, and clean, well-stocked shelves.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-dd01-77b5-8c7b-c9bab46ae8bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-dd01-77b5-8c7b-c9bab46ae8bf",
        "storage_key": "property/6767906449165642/019d7913-dd01-77b5-8c7b-c9bab46ae8bf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14273686067937202546&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.5828942",
      "poi_longitude": "-97.6374351",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-709-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7e27-7684-9a4f-6e4ab8dd2cc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7e27-7684-9a4f-6e4ab8dd2cc9",
        "storage_key": "property/6767906449165642/019cfb4c-7e27-7684-9a4f-6e4ab8dd2cc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnxzFj54EsocRctHWgtpRFsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_bcc60230-50d7-45e8-b21c-dc1ff6c6733e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "12200 N MacArthur Blvd Ste C, Oklahoma City, OK 73162, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers fresh produce, fruits, and vegetables, as well as a good selection of meat, seafood, and organic and whole foods. They also highlight the friendly and helpful staff, the clean and well-organized store, and the great selection of flowers and bulk items.\n\nOther reviews mention some items can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-ddb6-773a-8afc-31a8b5c3bb11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ddb6-773a-8afc-31a8b5c3bb11",
        "storage_key": "property/6767906449165642/019d7913-ddb6-773a-8afc-31a8b5c3bb11.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://sprouts.com/store/ok/oklahoma-city/nw-oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=5963094106256639797&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.5931906",
      "poi_longitude": "-97.6193742",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-384-7577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7e27-7684-9a4f-6e4ab8dd2cc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7e27-7684-9a4f-6e4ab8dd2cc9",
        "storage_key": "property/6767906449165642/019cfb4c-7e27-7684-9a4f-6e4ab8dd2cc9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ54g9xlADsocRNQen7X4qwVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6cda90db-e265-4256-8e10-a80e0b0a1680",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "OKC Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "7624 W Reno Ave Suite 380, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Relaxed outdoor mall featuring more than 70 brand-name designer stores of shoes, clothing and more.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores and good deals, especially during sales. They also highlight the clean and well-maintained facilities, and the friendly and helpful service.\n\nOther reviews mention the food court can have limited options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-e58d-708c-b103-8c513bb9f508.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e58d-708c-b103-8c513bb9f508",
        "storage_key": "property/6767906449165642/019d7913-e58d-708c-b103-8c513bb9f508.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.okcoutlets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1773095145334850603&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "okc-outlets",
      "poi_latitude": "35.4625898",
      "poi_longitude": "-97.6473972",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 405-787-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-405169c1121c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-405169c1121c",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-405169c1121c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdWyLw68PsocRK0Sn8qNMmxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_511b932d-526d-4cdc-a5b5-bca2dfa06a7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Penn Square Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "1901 Northwest Expy, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Classic enclosed mall with department stores, services & a food court, plus ample parking.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including clothing, specialty shops, and dining choices. They also highlight the fun and laid-back atmosphere, and the clean and well-maintained facilities.\n\nSome reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-e527-7471-b707-4fa61417f059.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e527-7471-b707-4fa61417f059",
        "storage_key": "property/6767906449165642/019d7913-e527-7471-b707-4fa61417f059.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/penn-square-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=2811350003534984838&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "penn-square-mall",
      "poi_latitude": "35.5249271",
      "poi_longitude": "-97.5441961",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-842-4424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-405169c1121c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-405169c1121c",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-405169c1121c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqd3wbBUasocRhvb-2-7rAyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_93e211d1-62a6-433d-b49c-52908cda08e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Silver Springs Pointe",
      "poi_type": "Shopping & Retail",
      "poi_address": "9001 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Bustling shopping center with a range of stores, including Walmart.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-e581-72be-9362-2496fc48c6a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e581-72be-9362-2496fc48c6a8",
        "storage_key": "property/6767906449165642/019d7913-e581-72be-9362-2496fc48c6a8.webp",
        "width": 882,
        "height": 588
      },
      "poi_business_url": "https://kiterealty.com/properties/silver-springs-pointe",
      "poi_directions_map_url": "https://maps.google.com/?cid=5394108430922283156&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "silver-springs-pointe",
      "poi_latitude": "35.5621298",
      "poi_longitude": "-97.6505021",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-451-2551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-405169c1121c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-405169c1121c",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-405169c1121c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAS8LovQEsocRlPgP6Qm520o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1dc8fd78-0bd8-4247-b7f1-4ee9a0ecc82f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Shoppes at Quail Springs",
      "poi_type": "Shopping & Retail",
      "poi_address": "13601 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Shopping mall providing a range of dining and retail options, plus services such as a nail salon.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-e67d-71f5-bef3-1ec87094b781.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e67d-71f5-bef3-1ec87094b781",
        "storage_key": "property/6767906449165642/019d7913-e67d-71f5-bef3-1ec87094b781.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14927123804922769544&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "shoppes-at-quail-springs",
      "poi_latitude": "35.6077308",
      "poi_longitude": "-97.5682449",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-239-1221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-405169c1121c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-405169c1121c",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-405169c1121c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7-hS3mEcsocRiPCyZgPMJ88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_d591fb25-f689-47af-ac9e-9b987a80c4c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Council Crossings Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "Oklahoma City, OK 73162, USA",
      "poi_short_description": "Shopping center including Ollie's Bargain Outlet, Goodwill, and an Italian restaurant.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-ebcb-7499-9161-3097709d7366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ebcb-7499-9161-3097709d7366",
        "storage_key": "property/6767906449165642/019d7913-ebcb-7499-9161-3097709d7366.webp",
        "width": 500,
        "height": 332
      },
      "poi_business_url": "http://jahrealty.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9778614970596235377&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "council-crossings-shopping-center",
      "poi_latitude": "35.5678055",
      "poi_longitude": "-97.6585951",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-405169c1121c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-405169c1121c",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-405169c1121c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJO_o7aWEEsocRcZi0pYGetIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f34ff698-679f-4ca5-ba44-f44d1f659a6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Quail Creek Golf & Country Club",
      "poi_type": "Entertainment",
      "poi_address": "3501 Quail Creek Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Upscale facility, owned by members, featuring golf courses and tennis courts, plus a pool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-ec87-702e-95f3-f6c5020c5f0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ec87-702e-95f3-f6c5020c5f0b",
        "storage_key": "property/6767906449165642/019d7913-ec87-702e-95f3-f6c5020c5f0b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.quailcreekgcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3160679487445955446&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "quail-creek-golf-country-club",
      "poi_latitude": "35.5992235",
      "poi_longitude": "-97.5817331",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-751-0811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7e04-726d-bf2e-85f7bb575c60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7e04-726d-bf2e-85f7bb575c60",
        "storage_key": "property/6767906449165642/019cfb4c-7e04-726d-bf2e-85f7bb575c60.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJdotho8csocRdnMUcj_93Cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_94567cb0-da19-48fe-aaee-c8906df3b020",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Oklahoma City Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2000 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Zoo with an array of animals, plus walking trails, shows & attractions such as train tours.",
      "poi_long_description": "Visitors say this zoo offers a wide variety of animals, including elephants, giraffes, stingrays, and a petting zoo, with fun activities like giraffe feeding and a splash pad. They also highlight the friendly and helpful staff, the clean and well-maintained facilities, and the affordable prices, especially with discounts for families and military members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-f35a-714e-94f6-a7958fd6dc2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f35a-714e-94f6-a7958fd6dc2a",
        "storage_key": "property/6767906449165642/019d7913-f35a-714e-94f6-a7958fd6dc2a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://okczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013321368135377402&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-zoo",
      "poi_latitude": "35.5238895",
      "poi_longitude": "-97.4724932",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-424-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7e04-726d-bf2e-85f7bb575c60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7e04-726d-bf2e-85f7bb575c60",
        "storage_key": "property/6767906449165642/019cfb4c-7e04-726d-bf2e-85f7bb575c60.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_EZ4YPguocR-qGV_DjlkkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_22280721-d72f-4833-8254-b0771f1375c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Oklahoma City National Memorial & Museum",
      "poi_type": "Entertainment",
      "poi_address": "620 N Harvey Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "A garden, pool & sculptural memorial commemorating victims of the 1995 Murrah Building bombing.",
      "poi_long_description": "Visitors say this memorial and museum offers a moving experience, honoring the lives lost in the 1995 Oklahoma City bombing. They also highlight the peaceful and serene atmosphere, with many finding it a place for quiet reflection and remembrance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-f33b-7077-801e-1facc1c95589.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f33b-7077-801e-1facc1c95589",
        "storage_key": "property/6767906449165642/019d7913-f33b-7077-801e-1facc1c95589.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://memorialmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4635276338053722639&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-national-memorial-museum",
      "poi_latitude": "35.4731496",
      "poi_longitude": "-97.5170593",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "5 hours 2 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-235-3313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7e0d-73c9-a53b-362ccf002356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7e0d-73c9-a53b-362ccf002356",
        "storage_key": "property/6767906449165642/019cfb4c-7e0d-73c9-a53b-362ccf002356.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq81FLi4XsocRDzJ3TUXPU0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1bffa637-b261-4355-bbd9-a3d69f7088a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "National Cowboy & Western Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "1700 NE 63rd St, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Dioramas, artifacts, art & more documenting & interpreting the history of the American West.",
      "poi_long_description": "People say this heritage museum offers a vast collection of Western art, artifacts, and historical exhibits, including sculptures, paintings, clothing, and personal items from historical figures. They highlight the educational and family-friendly atmosphere, with engaging multi-media displays, outdoor exhibits, and a playground. They also like the friendly and knowledgeable staff, and the informative presentations by docents. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-f2ac-75f9-9fa1-ea9ee3f22fd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f2ac-75f9-9fa1-ea9ee3f22fd4",
        "storage_key": "property/6767906449165642/019d7913-f2ac-75f9-9fa1-ea9ee3f22fd4.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://nationalcowboymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4849781199640138445&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "national-cowboy-western-heritage-museum",
      "poi_latitude": "35.5356997",
      "poi_longitude": "-97.4831286",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-478-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7e0d-73c9-a53b-362ccf002356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7e0d-73c9-a53b-362ccf002356",
        "storage_key": "property/6767906449165642/019cfb4c-7e0d-73c9-a53b-362ccf002356.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-cenbQZsocRzRLrSk7iTUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ba465038-49d9-49da-87aa-0b00df59300c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Bricktown Brewery",
      "poi_type": "Entertainment",
      "poi_address": "5516 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Craft beer and local bites served in a casual restaurant with a kids' menu, happy hours, and a rooftop.",
      "poi_long_description": "People say this restaurant serves delicious burgers, salads, and soups. They highlight the reasonable prices and the fun, lively atmosphere with lots of TVs for sports. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-faae-71f7-92a6-087e029b2db3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-faae-71f7-92a6-087e029b2db3",
        "storage_key": "property/6767906449165642/019d7913-faae-71f7-92a6-087e029b2db3.webp",
        "width": 823,
        "height": 1280
      },
      "poi_business_url": "https://bricktownbrewery.com/location/memorial/?utm_source=gbp&utm_medium=cpc&utm_campaign=bricktown_brewery",
      "poi_directions_map_url": "https://maps.google.com/?cid=12384407661293981815&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bricktown-brewery",
      "poi_latitude": "35.6084008",
      "poi_longitude": "-97.6163922",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-594-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7dfb-721a-80f1-47a19ec59783",
        "storage_key": "property/6767906449165642/019cfb4c-7dfb-721a-80f1-47a19ec59783.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF_j7GW8DsocRd9ANDSdB3qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cddcea98-af37-4e74-bef4-42cc0d9afb7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Museum of Osteology",
      "poi_type": "Entertainment",
      "poi_address": "10301 S Sunnylane Rd, Oklahoma City, OK 73160, USA",
      "poi_short_description": "Unique spot for educational exhibits of 300+ skeletons of many species plus hands-on displays.",
      "poi_long_description": "Visitors say this museum offers a unique experience with a vast collection of skeletons, including animals, humans, and forensic exhibits. They also highlight the friendly and knowledgeable staff, educational value, and engaging scavenger hunts for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-fb16-75cd-83c2-1464a1fa0d61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-fb16-75cd-83c2-1464a1fa0d61",
        "storage_key": "property/6767906449165642/019d7913-fb16-75cd-83c2-1464a1fa0d61.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.skeletonmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9091622308725140297&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "museum-of-osteology",
      "poi_latitude": "35.3648349",
      "poi_longitude": "-97.4418414",
      "poi_miles_from_property": "24.6 mi",
      "poi_walking_minutes": "9 hours 13 mins",
      "poi_biking_minutes": "2 hours 27 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 405-814-0006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7e0d-73c9-a53b-362ccf002356.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7e0d-73c9-a53b-362ccf002356",
        "storage_key": "property/6767906449165642/019cfb4c-7e0d-73c9-a53b-362ccf002356.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ57ahxGMVsocRSSuU_1HuK34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_655bad14-3606-4bca-a830-928b9152ead5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Myriad Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "301 W Reno Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "A 15-acre facility with formal gardens, a tropical conservatory, a dog park & horticultural classes.",
      "poi_long_description": "People say this botanical garden offers a wide variety of plants, including tropical plants, orchids, and tulips, and features a conservatory, greenhouse, and walking paths. They highlight the beautiful and peaceful atmosphere, perfect for relaxing and taking photos, and the family-friendly amenities, such as a playground, splash pad, and carousel. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-ff5f-744f-bb7a-0bc2801a9cb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ff5f-744f-bb7a-0bc2801a9cb4",
        "storage_key": "property/6767906449165642/019d7913-ff5f-744f-bb7a-0bc2801a9cb4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.myriadgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10363530004578021372&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "myriad-botanical-gardens",
      "poi_latitude": "35.46533110000001",
      "poi_longitude": "-97.5179073",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 12 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-445-7080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7e04-726d-bf2e-85f7bb575c60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7e04-726d-bf2e-85f7bb575c60",
        "storage_key": "property/6767906449165642/019cfb4c-7e04-726d-bf2e-85f7bb575c60.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA05XnykXsocR_K_5faGn0o8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_32c1321f-413b-4c4b-b905-d1584d1ca32c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Oklahoma Centennial Land Run Monument",
      "poi_type": "Entertainment",
      "poi_address": "Oklahoma Centennial Land Run Monument, Oklahoma City, OK 73129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7677821841414544103&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-centennial-land-run-monument",
      "poi_latitude": "35.4614521",
      "poi_longitude": "-97.5049335",
      "poi_miles_from_property": "14.6 mi",
      "poi_walking_minutes": "5 hours 32 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7e04-726d-bf2e-85f7bb575c60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7e04-726d-bf2e-85f7bb575c60",
        "storage_key": "property/6767906449165642/019cfb4c-7e04-726d-bf2e-85f7bb575c60.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYe2gsd8WsocR59o_MkkajWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7bc61fbc-4083-457a-8fd1-6ddd1de90eca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Chickasaw Bricktown Ballpark",
      "poi_type": "Entertainment",
      "poi_address": "2 S Mickey Mantle Dr, Oklahoma City, OK 73104, USA",
      "poi_short_description": "Kid-friendly ballpark featuring minor-league baseball plus various themed promotions.",
      "poi_long_description": "People say this stadium offers a fun and affordable family experience with delicious hot dogs and a variety of food options. They highlight the great atmosphere, clean facilities, and easy access. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7913-ff49-7197-b648-bf66f5eb457e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ff49-7197-b648-bf66f5eb457e",
        "storage_key": "property/6767906449165642/019d7913-ff49-7197-b648-bf66f5eb457e.webp",
        "width": 1280,
        "height": 901
      },
      "poi_business_url": "http://www.okccomets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18040532731312389442&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chickasaw-bricktown-ballpark",
      "poi_latitude": "35.465199",
      "poi_longitude": "-97.507761",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 23 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-218-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7e0f-725a-bc22-4d62349bd4e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7e0f-725a-bc22-4d62349bd4e2",
        "storage_key": "property/6767906449165642/019cfb4c-7e0f-725a-bc22-4d62349bd4e2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV6DhxiAXsocRQr2usO_YXPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_3e4e5540-8e22-430b-b590-ddfa604b7e09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Oklahoma State Capitol",
      "poi_type": "Entertainment",
      "poi_address": "2300 N Lincoln Blvd, Oklahoma City, OK 73105, USA",
      "poi_short_description": "Iconic government building completed in 1917 featuring artwork, a veteran's memorial & guided tours.",
      "poi_long_description": "Iconic government building completed in 1917 featuring artwork, a veteran's memorial & guided tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7914-0232-71ac-bbdd-010097ede8eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7914-0232-71ac-bbdd-010097ede8eb",
        "storage_key": "property/6767906449165642/019d7914-0232-71ac-bbdd-010097ede8eb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ok.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1430115524182233952&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-state-capitol",
      "poi_latitude": "35.492221",
      "poi_longitude": "-97.5032462",
      "poi_miles_from_property": "13.2 mi",
      "poi_walking_minutes": "4 hours 55 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-521-3356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7914-0901-73d9-8e20-47e6dce846d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7914-0901-73d9-8e20-47e6dce846d2",
        "storage_key": "property/6767906449165642/019d7914-0901-73d9-8e20-47e6dce846d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBys1_0EXsocRYFOn_n3K2BM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_5f96434e-f792-405d-bcbf-83b2cb2e636a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "poi_name": "Paycom Center",
      "poi_type": "Entertainment",
      "poi_address": "100 W Reno Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "Home court to the NBA's Oklahoma City Thunder & venue for big-name concert acts & events.",
      "poi_long_description": "People say this arena offers a variety of events, including basketball games, concerts, and monster truck shows. They highlight the electric atmosphere, the friendly and helpful staff, and the easy parking and access. They also like the clean facilities and the good sightlines from every seat.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019d7914-028f-7544-b08b-2f80187249ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7914-028f-7544-b08b-2f80187249ed",
        "storage_key": "property/6767906449165642/019d7914-028f-7544-b08b-2f80187249ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.paycomcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11905088268860757061&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "paycom-center",
      "poi_latitude": "35.4635103",
      "poi_longitude": "-97.5150897",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 17 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-602-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-7e04-726d-bf2e-85f7bb575c60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4c-7e04-726d-bf2e-85f7bb575c60",
        "storage_key": "property/6767906449165642/019cfb4c-7e04-726d-bf2e-85f7bb575c60.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmW2-HCgXsocRRZQdZbReN6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    }
  ],
  "office_hours": [
    {
      "id": "ec_81b14bbbd7e4529cf3aec1e0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ac8bd328233d997fe8d21f12",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_235bcee0e50c34c17f395580",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e83df0f8fb1738dcfbb955cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_82d744a4869d1fa5266cc494",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_ae9421a32cf9eb6817a23f60",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_bf5d2f61-5aaf-425c-aa46-168498192f84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "rating": "5.0",
      "name": "Maria Victoria Saxton",
      "text": "The Staff at Warrington are amazing. They truly care about us the Residents. They do everything they can to address issues with grace and kindness. Maintenance  issues are addressed  quickly and professionally. Most work orders are completed within 24 hours .  The property is clean and well maintained. I love living here. I feel heard and safe.",
      "date": "2025-08-19",
      "title": ""
    },
    {
      "id": "custom_10abab25-cf61-4b89-a0ea-4e37487f3a90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "rating": "5.0",
      "name": "Wonderful Wonder",
      "text": "I love living at the Warrington Apartment. This has been my home for almost two years. The staff at the front desk are so kind and helpful. I feel like they are family. The maintenance staff is also friendly and helpful. The grounds are kept in beautiful condition. My neighbors are very respectful and considerate.. I am proud to share with others how much I love where I live. Sincerely, Nadine Bonds",
      "date": "2025-08-19",
      "title": ""
    },
    {
      "id": "custom_7bb5e8b0-0481-4892-9faa-43eb6a43eb4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "rating": "5.0",
      "name": "Stephanie",
      "text": "There was a water leak in an adjacent apartment which caused water damage in my apartment. I was at work when the leak was discovered, Kendall notified me immediately, met me at my apartment and assisted me in moving what we could then kept me posted with updates as repairs were completed! Kerry and his team addressed all repairs quickly and professionally, I was back in my apartment and it was good as new within the week!",
      "date": "2025-09-30",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e5a5edf8-d42a-4692-a8a2-5ee789df95a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4d-1411-702b-ab20-e701106c3854.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360\nicer of a swimming pool and lounge chairs at an apartment complex.",
        "public_id": "019cfb4d-1411-702b-ab20-e701106c3854",
        "storage_key": "property/6767906449165642/019cfb4d-1411-702b-ab20-e701106c3854.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Warrington Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=646cad5dc8219b74752e5523&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-7229-7168-8398-c205ff42dbe8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "warrington-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642"
    },
    {
      "lead_collector_id": "019cf79e-729e-7689-9621-840e4d7cd559",
      "lead_source": "LANDING_PAGE",
      "name": "warrington-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "apartments-with-pool-in-oklahoma-city",
      "search_query": "apartments with pool in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Oklahoma City",
      "h2_subtitle": "Discover apartments with a stunning pool in Oklahoma City. Dive into luxury and comfort at Warrington Apartments.",
      "page_copy": "Searching for apartments with a pool in Oklahoma City? Look no further than Warrington Apartments, where leisure and lifestyle blend seamlessly. Our residents enjoy cooling off in our sparkling pool, perfect for relaxation or a little splash with friends. Beyond the poolside, our spacious one- and two-bedroom floor plans invite you to experience the perfect blend of comfort and convenience.\n\nWarrington Apartments offers more than just a pool. Our community provides high-speed internet, controlled access, and a fully-equipped fitness center, making modern living both easy and enjoyable. Situated in the charming Val Verde neighborhood, you will feel right at home with cozy interior features like fireplaces and walk-in closets. Come see why our pool alone is a reason to call Warrington Apartments your new home in Oklahoma City!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Oklahoma City",
      "seo_description": "Find apartments with a pool in Oklahoma City at Warrington Apartments. Enjoy spacious living and modern amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-val-verde-ok",
      "search_query": "fitness center apartments Val Verde OK",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Val Verde, OK",
      "h2_subtitle": "Explore apartments with a fitness center in Val Verde, OK. Stay active and energized at Warrington Apartments.",
      "page_copy": "Looking for fitness center apartments in Val Verde, OK? Warrington Apartments presents an ideal blend of convenience and active living. Our state-of-the-art fitness center is perfect for those looking to maintain a healthy lifestyle without leaving home. Whether you're into intense cardio sessions or gentle stretching, our facility offers all you need to keep up with your routine.\n\nNestled in the Val Verde neighborhood of Oklahoma City, Warrington Apartments offers more than just an excellent fitness facility. Our community features one- and two-bedroom layouts equipped with modern amenities such as high-speed internet access, fireplaces, and walk-in closets. After a workout, unwind in our beautiful courtyards or enjoy a peaceful evening on your own porch. Discover the benefits of combining fitness and comfortable living at Warrington Apartments!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Val Verde, OK",
      "seo_description": "Discover fitness center-equipped apartments in Val Verde, OK at Warrington Apartments. Enjoy modern amenities and active living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "gated-community-apartments-73142",
      "search_query": "gated community apartments 73142",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in 73142",
      "h2_subtitle": "Find security and peace of mind in gated community apartments, 73142. Explore Warrington Apartments today.",
      "page_copy": "Experience the comfort and safety of living in gated community apartments in the 73142 area at Warrington Apartments. Our community offers controlled access, ensuring a secure and serene living environment for all our residents. Located in Oklahoma City's desirable Val Verde neighborhood, peace and tranquility are just steps away from your front door.\n\nIn addition to our gated entry, Warrington Apartments boasts a variety of attractive amenities. Enjoy the convenience of high-speed internet, relax by our sparkling pool, or maintain your health goals in our well-equipped fitness center. Our spacious one- and two-bedroom apartments feature thoughtful design elements like fireplaces and walk-in closets, making everyday living a delight. Discover how our secure community can elevate your lifestyle in the vibrant 73142 zip code!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments in 73142",
      "seo_description": "Discover gated community apartments in the 73142 area at Warrington Apartments. Enjoy secure living with modern amenities in a vibrant Oklahoma City community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "apartments-with-fireplaces-oklahoma-city",
      "search_query": "apartments with fireplaces in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with Fireplaces in Oklahoma City",
      "h2_subtitle": "Find cozy apartments with fireplaces in Oklahoma City. Discover warmth and comfort at Warrington Apartments.",
      "page_copy": "If you're searching for apartments with fireplaces in Oklahoma City, Warrington Apartments is the perfect place to call home. Our cozy interiors feature inviting fireplaces that create a warm and comfortable ambiance. Ideal for snuggling up during cooler evenings, our fireplaces add a touch of elegance and relaxation to everyday living.\n\nLocated in the welcoming Val Verde neighborhood, Warrington Apartments offers more than just warmth and charm. Residents enjoy a host of amenities, including a sparkling pool, high-speed internet, and a fully-equipped fitness center. Spacious one- and two-bedroom layouts include walk-in closets and ceiling fans, enhancing your living experience. Discover the charm and convenience of fireplaces and much more at Warrington Apartments in Oklahoma City!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fireplaces in Oklahoma City",
      "seo_description": "Cozy up in apartments with fireplaces in Oklahoma City at Warrington Apartments. Enjoy comfort and modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "walk-in-closet-apartments-val-verde",
      "search_query": "walk-in closet apartments Val Verde",
      "category": "Amenity",
      "h1_title": "Walk-In Closet Apartments in Val Verde",
      "h2_subtitle": "Discover apartments with walk-in closets in Val Verde. Enjoy ample storage space at Warrington Apartments.",
      "page_copy": "Are you searching for walk-in closet apartments in the Val Verde neighborhood? Warrington Apartments offers spacious units that cater to your storage needs with generously sized walk-in closets. Whether you have a vast wardrobe or need extra space for storage, our closets provide convenient solutions.\n\nLocated in the heart of Val Verde, Oklahoma City, Warrington Apartments pairs ample storage with modern amenities. Residents enjoy perks like high-speed internet, a sparkling pool, and a fitness center. Each one- and two-bedroom apartment features fireplaces and ceiling fans, designed to enhance your comfort. Explore the benefits of additional space and modern living at Warrington Apartments in Val Verde.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Walk-In Closet Apartments in Val Verde",
      "seo_description": "Find spacious walk-in closet apartments in Val Verde at Warrington Apartments. Enjoy modern living with expansive storage in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-oklahoma-city-ok",
      "search_query": "one bedroom apartments in Oklahoma City OK",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Oklahoma City, OK",
      "h2_subtitle": "Explore comfortable one bedroom apartments in Oklahoma City, OK. Discover your perfect home at Warrington Apartments.",
      "page_copy": "Looking for one bedroom apartments in Oklahoma City, OK? Warrington Apartments offers beautifully designed spaces that encompass both comfort and style. Our one-bedroom layouts feature inviting fireplaces, spacious living areas, and walk-in closets, providing both functionality and a warm ambiance.\n\nNestled in the lively Val Verde neighborhood, residents have exclusive access to premium amenities, including a sparkling pool, high-speed internet, and a state-of-the-art fitness center. With thoughtful details like ceiling fans and cozy porches in each apartment, Warrington Apartments delivers an exceptional living experience in Oklahoma City. Find your cozy one-bedroom home today at a community that caters to your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Oklahoma City, OK",
      "seo_description": "Discover stylish one bedroom apartments in Oklahoma City, OK at Warrington Apartments. Enjoy modern amenities and cozy living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-val-verde-ok",
      "search_query": "two bedroom apartments Val Verde OK",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Val Verde, OK",
      "h2_subtitle": "Discover spacious two bedroom apartments in Val Verde, OK. Experience modern comfort at Warrington Apartments.",
      "page_copy": "Searching for two bedroom apartments in Val Verde, OK? Warrington Apartments offers expansive two-bedroom layouts that cater to both comfort and convenience. Each apartment features cozy interiors with fireplaces, providing a welcoming atmosphere ideal for family or shared living.\n\nSituated in the charming Val Verde neighborhood, Warrington Apartments boasts an array of desirable amenities. Residents enjoy high-speed internet, controlled access, and a well-equipped fitness center. With additional features like walk-in closets and ceiling fans, our two-bedroom homes are designed to elevate your living experience. Choose Warrington Apartments for quality living in a vibrant Oklahoma City community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Val Verde, OK",
      "seo_description": "Find spacious two bedroom apartments in Val Verde, OK at Warrington Apartments. Enjoy a welcoming community with modern amenities and cozy interiors.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "apartments-near-southern-nazarene-university-oklahoma-city",
      "search_query": "apartments near Southern Nazarene University Oklahoma City",
      "category": "School",
      "h1_title": "Apartments Near Southern Nazarene University",
      "h2_subtitle": "Find the perfect apartments near Southern Nazarene University in Oklahoma City. Discover Warrington Apartments for student-friendly living.",
      "page_copy": "If you're searching for apartments near Southern Nazarene University in Oklahoma City, consider Warrington Apartments your top choice. Our welcoming community offers the ideal location for students seeking easy access to campus while enjoying a vibrant off-campus lifestyle. With spacious one- and two-bedroom options, you'll find comfort and convenience just minutes from the university.\n\nLocated in the bustling Val Verde neighborhood, Warrington Apartments provides residents with premium amenities like a fitness center and a refreshing pool—perfect for unwinding after a busy day. Each apartment features cozy fireplaces, roomy walk-in closets, and high-speed internet access, making it a comfortable and practical choice for students. Experience convenient lifestyle choices and a supportive community at Warrington Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Southern Nazarene University",
      "seo_description": "Discover student-friendly apartments near Southern Nazarene University at Warrington Apartments. Enjoy a vibrant community and modern amenities, minutes from campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "apartments-near-integris-health-baptist-medical-center-oklahoma-city",
      "search_query": "apartments near INTEGRIS Health Baptist Medical Center Oklahoma City",
      "category": "Hospital",
      "h1_title": "Apartments Near INTEGRIS Health Baptist Medical",
      "h2_subtitle": "Discover convenient apartments near INTEGRIS Health Baptist Medical Center in Oklahoma City. Warrington Apartments offers a prime location and modern amenities.",
      "page_copy": "For those seeking apartments near INTEGRIS Health Baptist Medical Center in Oklahoma City, Warrington Apartments provides the perfect blend of convenience and comfort. Situated in the vibrant Val Verde area, our community is ideal for healthcare professionals or anyone who wants quick access to the medical center while enjoying a serene living environment.\n\nOur spacious one- and two-bedroom layouts are designed with modern living in mind, featuring amenities such as high-speed internet access, a fitness center, and a relaxing pool. Each apartment is crafted to offer a cozy haven, with thoughtful touches like fireplaces and ceiling fans. Warrington Apartments not only places you near essential medical facilities but also surrounds you with a welcoming community and numerous lifestyle conveniences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near INTEGRIS Health Baptist Medical Center",
      "seo_description": "Find comfortable apartments near INTEGRIS Health Baptist Medical Center at Warrington Apartments, offering modern amenities and a prime Oklahoma City location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "apartments-close-to-mercy-hospital-okc-val-verde",
      "search_query": "apartments close to Mercy Hospital OKC Val Verde",
      "category": "Hospital",
      "h1_title": "Apartments Close to Mercy Hospital OKC",
      "h2_subtitle": "Discover convenience with apartments close to Mercy Hospital OKC in Val Verde. Warrington Apartments combines prime location and comfort.",
      "page_copy": "Warrington Apartments is an ideal choice for those in search of apartments close to Mercy Hospital OKC, located conveniently in Val Verde. Our community offers easy accessibility to healthcare professionals and patients, making it perfect for those who desire proximity to this essential healthcare facility.\n\nEnjoy spacious one- and two-bedroom apartments with modern amenities such as high-speed internet, a full fitness center, and a shimmering pool. Each unit is designed for comfort, featuring cozy fireplaces and ceiling fans. With controlled access and beautiful courtyards, Warrington Apartments provides a peaceful and secure living environment just minutes from Mercy Hospital. Experience the harmonious blend of ease and comfort in a vibrant Oklahoma City neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Mercy Hospital OKC - Val Verde",
      "seo_description": "Explore Warrington Apartments, located close to Mercy Hospital OKC in Val Verde. Enjoy modern living with easy hospital access and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "apartments-near-martin-park-nature-center-okc",
      "search_query": "apartments near Martin Park Nature Center OKC",
      "category": "Park",
      "h1_title": "Apartments Near Martin Park Nature Center",
      "h2_subtitle": "Explore apartments near Martin Park Nature Center in OKC. Enjoy peaceful living at Warrington Apartments with access to nature and excellent amenities.",
      "page_copy": "If you're looking for apartments near Martin Park Nature Center in OKC, Warrington Apartments offers the perfect blend of nature and modern living. Situated in the serene Val Verde neighborhood, our community grants residents easy access to the scenic trails and abundant wildlife of the park, perfect for nature lovers and outdoor enthusiasts.\n\nThe spacious one- and two-bedroom floor plans feature cozy interiors with fireplaces and walk-in closets. Residents can also enjoy on-site amenities such as a fitness center, pool, and high-speed internet access. Warrington Apartments not only brings you close to the natural beauty of Martin Park but also provides a peaceful retreat with everything you need for comfortable living right at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Martin Park Nature Center OKC",
      "seo_description": "Find tranquility at Warrington Apartments near Martin Park Nature Center in OKC, offering nature access and modern amenities in Val Verde.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "stars-and-stripes-park-nearby-val-verde-apartments",
      "search_query": "Stars and Stripes Park nearby Val Verde apartments",
      "category": "Park",
      "h1_title": "Explore Stars and Stripes Park Nearby",
      "h2_subtitle": "Discover Stars and Stripes Park nearby Val Verde apartments. Enhance your lifestyle living at Warrington Apartments with easy park access.",
      "page_copy": "Residents of Warrington Apartments situated in Val Verde enjoy the perfect balance of urban and outdoor living with Stars and Stripes Park nearby. This picturesque park offers a great escape for outdoor activities like jogging, picnicking, or simply unwinding by the water, providing an ideal complement to apartment living.\n\nWarrington Apartments features well-designed one- and two-bedroom layouts, fitted with modern amenities such as high-speed internet and ceiling fans. The community offers a refreshing pool and a fully equipped fitness center, enhancing your active lifestyle. With controlled access and cozy interiors, including fireplaces, Warrington Apartments ensures a comfortable and secure environment, while being just minutes from the recreational opportunities at Stars and Stripes Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stars and Stripes Park Near Val Verde Apts",
      "seo_description": "Live at Warrington Apartments in Val Verde, with Stars and Stripes Park nearby. Enjoy a vibrant community and easy access to outdoor recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "bluff-creek-park-close-to-oklahoma-city-rentals",
      "search_query": "Bluff Creek Park close to Oklahoma City rentals",
      "category": "Park",
      "h1_title": "Rentals Near Bluff Creek Park OKC",
      "h2_subtitle": "Discover Bluff Creek Park close to Oklahoma City rentals. Enjoy nature and comfort at Warrington Apartments in Val Verde, just minutes away.",
      "page_copy": "Warrington Apartments, nestled in Val Verde, offers the ideal location for those seeking rentals close to Bluff Creek Park in Oklahoma City. This vibrant park provides extensive biking and walking trails among native landscapes, perfect for nature enthusiasts looking to explore the outdoors near their new home.\n\nAt Warrington Apartments, residents enjoy spacious one- and two-bedroom units that provide modern conveniences such as high-speed internet and cozy interiors with fireplaces. Take advantage of the fitness center and sparkling swimming pool within our community. With a prime location just moments from Bluff Creek Park and the added benefits of controlled access and beautiful courtyards, Warrington Apartments is the perfect choice for comfortable living with a touch of nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Bluff Creek Park OKC",
      "seo_description": "Explore Warrington Apartments in Val Verde, offering rentals near Bluff Creek Park OKC with modern amenities and easy access to outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165642",
      "source": "generator",
      "page_item_url": "dolese-park-vicinity-apartment-listings-okc",
      "search_query": "Dolese Park vicinity apartment listings OKC",
      "category": "Park",
      "h1_title": "Apartment Listings Near Dolese Park",
      "h2_subtitle": "Explore apartment listings near Dolese Park in OKC. Experience the comfort and convenience of Warrington Apartments in the Val Verde neighborhood.",
      "page_copy": "For those searching for apartment listings near Dolese Park in OKC, Warrington Apartments presents an ideal choice. Located in the peaceful Val Verde area, our community offers a serene setting with convenient access to the recreational opportunities at Dolese Park, known for its sports facilities and green spaces.\n\nWarrington Apartments features spacious one- and two-bedroom floor plans designed for modern living. Residents can enjoy a range of amenities, including controlled access, a state-of-the-art fitness center, and a relaxing pool. With cozy interiors that boast fireplaces and walk-in closets, plus the added convenience of high-speed internet, Warrington Apartments ensures a comfortable lifestyle within close proximity to Dolese Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
      "featured_image_media": {
        "alt_text": "The Warrington apartment complex entrance sign and buildings.",
        "public_id": "019cfb4c-5efa-7384-ab6f-bcfed682e95c",
        "storage_key": "property/6767906449165642/019cfb4c-5efa-7384-ab6f-bcfed682e95c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apt Listings Near Dolese Park OKC",
      "seo_description": "Discover Warrington Apartments near Dolese Park in OKC. Enjoy modern amenities with easy access to local recreational areas and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5230"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-R4N0VGZ5J8"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151590"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/warrington-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NFZ5R3CV"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165642/019d1bda-d8ca-76df-acea-5ed2006b9719.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "855-908-2909"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "65bd41350a33143081663be8"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImNTMjhUckdueHhqeWE4REY5N3ZpTkE9PSIsInZhbHVlIjoiMTVLcG1wRXJwM2hMSWZBTnV2VDVMdz09IiwibWFjIjoiNmJiMmZhMzFiYTUxMWExNzgzNzA1Y2YxYTFkMDQ5MzljYWRmYTJkZGU3OWFmMWQzZWYzODdkNmJlY2EzNTVlOCJ9"
    }
  ],
  "custom_qb_id": "5230",
  "custom_ga4_id": "G-R4N0VGZ5J8",
  "custom_repli_id": "10041151590",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/warrington-apartments/register/",
  "custom_google_gtm_id": "GTM-NFZ5R3CV",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165642/019d1bda-d8ca-76df-acea-5ed2006b9719.pdf",
  "custom_ppc_tracking_phone_number": "855-908-2909",
  "custom_residentboost_apartment_id": "65bd41350a33143081663be8",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImNTMjhUckdueHhqeWE4REY5N3ZpTkE9PSIsInZhbHVlIjoiMTVLcG1wRXJwM2hMSWZBTnV2VDVMdz09IiwibWFjIjoiNmJiMmZhMzFiYTUxMWExNzgzNzA1Y2YxYTFkMDQ5MzljYWRmYTJkZGU3OWFmMWQzZWYzODdkNmJlY2EzNTVlOCJ9"
};

export const generatedAt = '2026-08-27T21:35:06.873Z';
